/* eslint-disable */

/*
 * This file was generated using the AJV-CLI (see: https://github.com/ajv-validator/ajv-cli)
 *
 * Installing the AJV-CLI:
 * npm install -g ajv-cli
 *
 * The CLI-command used from the cms-directory (/aas2-cms/cms):
 * ajv compile --allow-union-types --code-lines -s src/components/conditionschema_complete.json -s src/components/conditionschema_simplified.json -o src/components/conditionschemas_compiled.js
 *
 * ESLint is disabled for this file to avoid build-problems.
 *
 * This file needs to be recompiled every time at least one of the schemas is changed.
 * The comments were added by hand and should be added after compilation.
 */

"use strict";
exports.validateComplete = validate20;
const schema22 = {"$id":"validateComplete","$schema":"http://json-schema.org/draft-07/schema#","definitions":{"condition":{"type":"object","properties":{"nodeType":{"type":"string","enum":["and","or","not","leaf"]},"children":{"type":"array","items":{"$ref":"#/definitions/condition"},"minItems":1},"leafType":{"type":"string","enum":["question","slider","date","text","table"]},"questionLabel":{"type":"string"},"value":{"type":["number","string","boolean"]},"operation":{"type":"string","enum":["less","lessEqual","greater","greaterEqual","equals","notEquals","between","answered"]},"secondValue":{"type":["number","string"]}},"required":["nodeType"],"additionalProperties":false,"allOf":[{"$ref":"#/definitions/and-or-not-require-children"},{"$ref":"#/definitions/leaf-requires-leafattributes"}]},"and-or-not-require-children":{"oneOf":[{"$ref":"#/definitions/is-leaf"},{"allOf":[{"not":{"$ref":"#/definitions/is-leaf"}},{"$ref":"#/definitions/is-not"},{"type":"object","required":["children"]},{"not":{"type":"object","required":["leafType"]}},{"not":{"type":"object","required":["questionLabel"]}},{"not":{"type":"object","required":["value"]}},{"not":{"type":"object","required":["operation"]}},{"not":{"type":"object","required":["secondValue"]}},{"type":"object","properties":{"children":{"type":"array","maxItems":1}}}]},{"allOf":[{"not":{"$ref":"#/definitions/is-leaf"}},{"not":{"$ref":"#/definitions/is-not"}},{"type":"object","required":["children"]},{"not":{"type":"object","required":["leafType"]}},{"not":{"type":"object","required":["questionLabel"]}},{"not":{"type":"object","required":["value"]}},{"not":{"type":"object","required":["operation"]}},{"not":{"type":"object","required":["secondValue"]}},{"type":"object","properties":{"children":{"type":"array","minItems":2}}}]}]},"leaf-requires-leafattributes":{"oneOf":[{"not":{"$ref":"#/definitions/is-leaf"}},{"allOf":[{"$ref":"#/definitions/is-question-leaf"},{"type":"object","required":["leafType","questionLabel"]},{"oneOf":[{"allOf":[{"not":{"type":"object","required":["operation"]}},{"type":"object","required":["value"]}]},{"allOf":[{"$ref":"#/definitions/has-operation-answered"},{"not":{"type":"object","required":["value"]}}]}]},{"not":{"type":"object","required":["secondValue"]}},{"not":{"type":"object","required":["children"]}},{"$ref":"#/definitions/value-type-is-boolean-string"}]},{"allOf":[{"$ref":"#/definitions/is-leaf"},{"not":{"$ref":"#/definitions/is-question-leaf"}},{"type":"object","required":["leafType","questionLabel"]},{"oneOf":[{"allOf":[{"not":{"$ref":"#/definitions/has-operation-answered"}},{"type":"object","required":["value"]}]},{"allOf":[{"$ref":"#/definitions/has-operation-answered"},{"not":{"type":"object","required":["value"]}}]}]},{"not":{"type":"object","required":["children"]}},{"oneOf":[{"$ref":"#/definitions/has-leaftype-slider"},{"$ref":"#/definitions/has-leaftype-table"},{"$ref":"#/definitions/has-leaftype-text"},{"$ref":"#/definitions/has-leaftype-date"}]},{"oneOf":[{"allOf":[{"not":{"$ref":"#/definitions/has-operation-between"}},{"not":{"type":"object","required":["secondValue"]}}]},{"allOf":[{"$ref":"#/definitions/has-operation-between"},{"type":"object","required":["secondValue"]}]}]}]}]},"is-leaf":{"type":"object","properties":{"nodeType":{"enum":["leaf"]}}},"is-not":{"type":"object","properties":{"nodeType":{"enum":["not"]}}},"is-question-leaf":{"type":"object","properties":{"nodeType":{"enum":["leaf"]},"leafType":{"enum":["question"]}}},"has-leaftype-slider":{"type":"object","properties":{"leafType":{"enum":["slider"]},"value":{"type":"number"},"secondValue":{"type":"number"}}},"has-leaftype-table":{"type":"object","properties":{"leafType":{"enum":["table"]},"value":{"type":"number"},"secondValue":{"type":"number"}}},"has-leaftype-date":{"type":"object","properties":{"leafType":{"enum":["date"]},"value":{"type":"string"},"secondValue":{"type":"string"}}},"has-leaftype-text":{"type":"object","properties":{"leafType":{"enum":["text"]},"not":{"type":"object","required":["value","secondValue"]}}},"has-operation-between":{"type":"object","properties":{"operation":{"enum":["between"]}}},"has-operation-answered":{"type":"object","properties":{"operation":{"enum":["answered"]}}},"value-type-is-boolean-string":{"type":"object","properties":{"value":{"type":["string","boolean"]}}}},"type":"object","properties":{"condition":{"$ref":"#/definitions/condition"}},"required":["condition"],"additionalProperties":false};
const schema23 = {"type":"object","properties":{"nodeType":{"type":"string","enum":["and","or","not","leaf"]},"children":{"type":"array","items":{"$ref":"#/definitions/condition"},"minItems":1},"leafType":{"type":"string","enum":["question","slider","date","text","table"]},"questionLabel":{"type":"string"},"value":{"type":["number","string","boolean"]},"operation":{"type":"string","enum":["less","lessEqual","greater","greaterEqual","equals","notEquals","between","answered"]},"secondValue":{"type":["number","string"]}},"required":["nodeType"],"additionalProperties":false,"allOf":[{"$ref":"#/definitions/and-or-not-require-children"},{"$ref":"#/definitions/leaf-requires-leafattributes"}]};
const schema24 = {"oneOf":[{"$ref":"#/definitions/is-leaf"},{"allOf":[{"not":{"$ref":"#/definitions/is-leaf"}},{"$ref":"#/definitions/is-not"},{"type":"object","required":["children"]},{"not":{"type":"object","required":["leafType"]}},{"not":{"type":"object","required":["questionLabel"]}},{"not":{"type":"object","required":["value"]}},{"not":{"type":"object","required":["operation"]}},{"not":{"type":"object","required":["secondValue"]}},{"type":"object","properties":{"children":{"type":"array","maxItems":1}}}]},{"allOf":[{"not":{"$ref":"#/definitions/is-leaf"}},{"not":{"$ref":"#/definitions/is-not"}},{"type":"object","required":["children"]},{"not":{"type":"object","required":["leafType"]}},{"not":{"type":"object","required":["questionLabel"]}},{"not":{"type":"object","required":["value"]}},{"not":{"type":"object","required":["operation"]}},{"not":{"type":"object","required":["secondValue"]}},{"type":"object","properties":{"children":{"type":"array","minItems":2}}}]}]};
const schema25 = {"type":"object","properties":{"nodeType":{"enum":["leaf"]}}};
const schema27 = {"type":"object","properties":{"nodeType":{"enum":["not"]}}};

function validate22(data, {instancePath="", parentData, parentDataProperty, rootData=data}={}){
let vErrors = null;
let errors = 0;
const _errs0 = errors;
let valid0 = false;
let passing0 = null;
const _errs1 = errors;
const _errs2 = errors;
if(errors === _errs2){
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.nodeType !== undefined){
if(!(data.nodeType === "leaf")){
const err0 = {instancePath:instancePath+"/nodeType",schemaPath:"#/definitions/is-leaf/properties/nodeType/enum",keyword:"enum",params:{allowedValues: schema25.properties.nodeType.enum},message:"must be equal to one of the allowed values"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
}
}
else {
const err1 = {instancePath,schemaPath:"#/definitions/is-leaf/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
}
var _valid0 = _errs1 === errors;
if(_valid0){
valid0 = true;
passing0 = 0;
}
const _errs5 = errors;
const _errs6 = errors;
const _errs7 = errors;
const _errs8 = errors;
const _errs9 = errors;
if(errors === _errs9){
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.nodeType !== undefined){
if(!(data.nodeType === "leaf")){
const err2 = {};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
}
}
else {
const err3 = {};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
}
var valid4 = _errs8 === errors;
if(valid4){
const err4 = {instancePath,schemaPath:"#/oneOf/1/allOf/0/not",keyword:"not",params:{},message:"must NOT be valid"};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
else {
errors = _errs7;
if(vErrors !== null){
if(_errs7){
vErrors.length = _errs7;
}
else {
vErrors = null;
}
}
}
var valid3 = _errs6 === errors;
if(valid3){
const _errs12 = errors;
const _errs13 = errors;
if(errors === _errs13){
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.nodeType !== undefined){
if(!(data.nodeType === "not")){
const err5 = {instancePath:instancePath+"/nodeType",schemaPath:"#/definitions/is-not/properties/nodeType/enum",keyword:"enum",params:{allowedValues: schema27.properties.nodeType.enum},message:"must be equal to one of the allowed values"};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
}
}
else {
const err6 = {instancePath,schemaPath:"#/definitions/is-not/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err6];
}
else {
vErrors.push(err6);
}
errors++;
}
}
var valid3 = _errs12 === errors;
if(valid3){
const _errs16 = errors;
if(errors === _errs16){
if(data && typeof data == "object" && !Array.isArray(data)){
let missing0;
if((data.children === undefined) && (missing0 = "children")){
const err7 = {instancePath,schemaPath:"#/oneOf/1/allOf/2/required",keyword:"required",params:{missingProperty: missing0},message:"must have required property '"+missing0+"'"};
if(vErrors === null){
vErrors = [err7];
}
else {
vErrors.push(err7);
}
errors++;
}
}
else {
const err8 = {instancePath,schemaPath:"#/oneOf/1/allOf/2/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err8];
}
else {
vErrors.push(err8);
}
errors++;
}
}
var valid3 = _errs16 === errors;
if(valid3){
const _errs18 = errors;
const _errs19 = errors;
const _errs20 = errors;
if(errors === _errs20){
if(data && typeof data == "object" && !Array.isArray(data)){
let missing1;
if((data.leafType === undefined) && (missing1 = "leafType")){
const err9 = {};
if(vErrors === null){
vErrors = [err9];
}
else {
vErrors.push(err9);
}
errors++;
}
}
else {
const err10 = {};
if(vErrors === null){
vErrors = [err10];
}
else {
vErrors.push(err10);
}
errors++;
}
}
var valid9 = _errs20 === errors;
if(valid9){
const err11 = {instancePath,schemaPath:"#/oneOf/1/allOf/3/not",keyword:"not",params:{},message:"must NOT be valid"};
if(vErrors === null){
vErrors = [err11];
}
else {
vErrors.push(err11);
}
errors++;
}
else {
errors = _errs19;
if(vErrors !== null){
if(_errs19){
vErrors.length = _errs19;
}
else {
vErrors = null;
}
}
}
var valid3 = _errs18 === errors;
if(valid3){
const _errs22 = errors;
const _errs23 = errors;
const _errs24 = errors;
if(errors === _errs24){
if(data && typeof data == "object" && !Array.isArray(data)){
let missing2;
if((data.questionLabel === undefined) && (missing2 = "questionLabel")){
const err12 = {};
if(vErrors === null){
vErrors = [err12];
}
else {
vErrors.push(err12);
}
errors++;
}
}
else {
const err13 = {};
if(vErrors === null){
vErrors = [err13];
}
else {
vErrors.push(err13);
}
errors++;
}
}
var valid10 = _errs24 === errors;
if(valid10){
const err14 = {instancePath,schemaPath:"#/oneOf/1/allOf/4/not",keyword:"not",params:{},message:"must NOT be valid"};
if(vErrors === null){
vErrors = [err14];
}
else {
vErrors.push(err14);
}
errors++;
}
else {
errors = _errs23;
if(vErrors !== null){
if(_errs23){
vErrors.length = _errs23;
}
else {
vErrors = null;
}
}
}
var valid3 = _errs22 === errors;
if(valid3){
const _errs26 = errors;
const _errs27 = errors;
const _errs28 = errors;
if(errors === _errs28){
if(data && typeof data == "object" && !Array.isArray(data)){
let missing3;
if((data.value === undefined) && (missing3 = "value")){
const err15 = {};
if(vErrors === null){
vErrors = [err15];
}
else {
vErrors.push(err15);
}
errors++;
}
}
else {
const err16 = {};
if(vErrors === null){
vErrors = [err16];
}
else {
vErrors.push(err16);
}
errors++;
}
}
var valid11 = _errs28 === errors;
if(valid11){
const err17 = {instancePath,schemaPath:"#/oneOf/1/allOf/5/not",keyword:"not",params:{},message:"must NOT be valid"};
if(vErrors === null){
vErrors = [err17];
}
else {
vErrors.push(err17);
}
errors++;
}
else {
errors = _errs27;
if(vErrors !== null){
if(_errs27){
vErrors.length = _errs27;
}
else {
vErrors = null;
}
}
}
var valid3 = _errs26 === errors;
if(valid3){
const _errs30 = errors;
const _errs31 = errors;
const _errs32 = errors;
if(errors === _errs32){
if(data && typeof data == "object" && !Array.isArray(data)){
let missing4;
if((data.operation === undefined) && (missing4 = "operation")){
const err18 = {};
if(vErrors === null){
vErrors = [err18];
}
else {
vErrors.push(err18);
}
errors++;
}
}
else {
const err19 = {};
if(vErrors === null){
vErrors = [err19];
}
else {
vErrors.push(err19);
}
errors++;
}
}
var valid12 = _errs32 === errors;
if(valid12){
const err20 = {instancePath,schemaPath:"#/oneOf/1/allOf/6/not",keyword:"not",params:{},message:"must NOT be valid"};
if(vErrors === null){
vErrors = [err20];
}
else {
vErrors.push(err20);
}
errors++;
}
else {
errors = _errs31;
if(vErrors !== null){
if(_errs31){
vErrors.length = _errs31;
}
else {
vErrors = null;
}
}
}
var valid3 = _errs30 === errors;
if(valid3){
const _errs34 = errors;
const _errs35 = errors;
const _errs36 = errors;
if(errors === _errs36){
if(data && typeof data == "object" && !Array.isArray(data)){
let missing5;
if((data.secondValue === undefined) && (missing5 = "secondValue")){
const err21 = {};
if(vErrors === null){
vErrors = [err21];
}
else {
vErrors.push(err21);
}
errors++;
}
}
else {
const err22 = {};
if(vErrors === null){
vErrors = [err22];
}
else {
vErrors.push(err22);
}
errors++;
}
}
var valid13 = _errs36 === errors;
if(valid13){
const err23 = {instancePath,schemaPath:"#/oneOf/1/allOf/7/not",keyword:"not",params:{},message:"must NOT be valid"};
if(vErrors === null){
vErrors = [err23];
}
else {
vErrors.push(err23);
}
errors++;
}
else {
errors = _errs35;
if(vErrors !== null){
if(_errs35){
vErrors.length = _errs35;
}
else {
vErrors = null;
}
}
}
var valid3 = _errs34 === errors;
if(valid3){
const _errs38 = errors;
if(errors === _errs38){
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.children !== undefined){
let data3 = data.children;
const _errs40 = errors;
if(errors === _errs40){
if(Array.isArray(data3)){
if(data3.length > 1){
const err24 = {instancePath:instancePath+"/children",schemaPath:"#/oneOf/1/allOf/8/properties/children/maxItems",keyword:"maxItems",params:{limit: 1},message:"must NOT have more than 1 items"};
if(vErrors === null){
vErrors = [err24];
}
else {
vErrors.push(err24);
}
errors++;
}
}
else {
const err25 = {instancePath:instancePath+"/children",schemaPath:"#/oneOf/1/allOf/8/properties/children/type",keyword:"type",params:{type: "array"},message:"must be array"};
if(vErrors === null){
vErrors = [err25];
}
else {
vErrors.push(err25);
}
errors++;
}
}
}
}
else {
const err26 = {instancePath,schemaPath:"#/oneOf/1/allOf/8/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err26];
}
else {
vErrors.push(err26);
}
errors++;
}
}
var valid3 = _errs38 === errors;
}
}
}
}
}
}
}
}
var _valid0 = _errs5 === errors;
if(_valid0 && valid0){
valid0 = false;
passing0 = [passing0, 1];
}
else {
if(_valid0){
valid0 = true;
passing0 = 1;
}
const _errs42 = errors;
const _errs43 = errors;
const _errs44 = errors;
const _errs45 = errors;
const _errs46 = errors;
if(errors === _errs46){
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.nodeType !== undefined){
if(!(data.nodeType === "leaf")){
const err27 = {};
if(vErrors === null){
vErrors = [err27];
}
else {
vErrors.push(err27);
}
errors++;
}
}
}
else {
const err28 = {};
if(vErrors === null){
vErrors = [err28];
}
else {
vErrors.push(err28);
}
errors++;
}
}
var valid16 = _errs45 === errors;
if(valid16){
const err29 = {instancePath,schemaPath:"#/oneOf/2/allOf/0/not",keyword:"not",params:{},message:"must NOT be valid"};
if(vErrors === null){
vErrors = [err29];
}
else {
vErrors.push(err29);
}
errors++;
}
else {
errors = _errs44;
if(vErrors !== null){
if(_errs44){
vErrors.length = _errs44;
}
else {
vErrors = null;
}
}
}
var valid15 = _errs43 === errors;
if(valid15){
const _errs49 = errors;
const _errs50 = errors;
const _errs51 = errors;
const _errs52 = errors;
if(errors === _errs52){
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.nodeType !== undefined){
if(!(data.nodeType === "not")){
const err30 = {};
if(vErrors === null){
vErrors = [err30];
}
else {
vErrors.push(err30);
}
errors++;
}
}
}
else {
const err31 = {};
if(vErrors === null){
vErrors = [err31];
}
else {
vErrors.push(err31);
}
errors++;
}
}
var valid19 = _errs51 === errors;
if(valid19){
const err32 = {instancePath,schemaPath:"#/oneOf/2/allOf/1/not",keyword:"not",params:{},message:"must NOT be valid"};
if(vErrors === null){
vErrors = [err32];
}
else {
vErrors.push(err32);
}
errors++;
}
else {
errors = _errs50;
if(vErrors !== null){
if(_errs50){
vErrors.length = _errs50;
}
else {
vErrors = null;
}
}
}
var valid15 = _errs49 === errors;
if(valid15){
const _errs55 = errors;
if(errors === _errs55){
if(data && typeof data == "object" && !Array.isArray(data)){
let missing6;
if((data.children === undefined) && (missing6 = "children")){
const err33 = {instancePath,schemaPath:"#/oneOf/2/allOf/2/required",keyword:"required",params:{missingProperty: missing6},message:"must have required property '"+missing6+"'"};
if(vErrors === null){
vErrors = [err33];
}
else {
vErrors.push(err33);
}
errors++;
}
}
else {
const err34 = {instancePath,schemaPath:"#/oneOf/2/allOf/2/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err34];
}
else {
vErrors.push(err34);
}
errors++;
}
}
var valid15 = _errs55 === errors;
if(valid15){
const _errs57 = errors;
const _errs58 = errors;
const _errs59 = errors;
if(errors === _errs59){
if(data && typeof data == "object" && !Array.isArray(data)){
let missing7;
if((data.leafType === undefined) && (missing7 = "leafType")){
const err35 = {};
if(vErrors === null){
vErrors = [err35];
}
else {
vErrors.push(err35);
}
errors++;
}
}
else {
const err36 = {};
if(vErrors === null){
vErrors = [err36];
}
else {
vErrors.push(err36);
}
errors++;
}
}
var valid22 = _errs59 === errors;
if(valid22){
const err37 = {instancePath,schemaPath:"#/oneOf/2/allOf/3/not",keyword:"not",params:{},message:"must NOT be valid"};
if(vErrors === null){
vErrors = [err37];
}
else {
vErrors.push(err37);
}
errors++;
}
else {
errors = _errs58;
if(vErrors !== null){
if(_errs58){
vErrors.length = _errs58;
}
else {
vErrors = null;
}
}
}
var valid15 = _errs57 === errors;
if(valid15){
const _errs61 = errors;
const _errs62 = errors;
const _errs63 = errors;
if(errors === _errs63){
if(data && typeof data == "object" && !Array.isArray(data)){
let missing8;
if((data.questionLabel === undefined) && (missing8 = "questionLabel")){
const err38 = {};
if(vErrors === null){
vErrors = [err38];
}
else {
vErrors.push(err38);
}
errors++;
}
}
else {
const err39 = {};
if(vErrors === null){
vErrors = [err39];
}
else {
vErrors.push(err39);
}
errors++;
}
}
var valid23 = _errs63 === errors;
if(valid23){
const err40 = {instancePath,schemaPath:"#/oneOf/2/allOf/4/not",keyword:"not",params:{},message:"must NOT be valid"};
if(vErrors === null){
vErrors = [err40];
}
else {
vErrors.push(err40);
}
errors++;
}
else {
errors = _errs62;
if(vErrors !== null){
if(_errs62){
vErrors.length = _errs62;
}
else {
vErrors = null;
}
}
}
var valid15 = _errs61 === errors;
if(valid15){
const _errs65 = errors;
const _errs66 = errors;
const _errs67 = errors;
if(errors === _errs67){
if(data && typeof data == "object" && !Array.isArray(data)){
let missing9;
if((data.value === undefined) && (missing9 = "value")){
const err41 = {};
if(vErrors === null){
vErrors = [err41];
}
else {
vErrors.push(err41);
}
errors++;
}
}
else {
const err42 = {};
if(vErrors === null){
vErrors = [err42];
}
else {
vErrors.push(err42);
}
errors++;
}
}
var valid24 = _errs67 === errors;
if(valid24){
const err43 = {instancePath,schemaPath:"#/oneOf/2/allOf/5/not",keyword:"not",params:{},message:"must NOT be valid"};
if(vErrors === null){
vErrors = [err43];
}
else {
vErrors.push(err43);
}
errors++;
}
else {
errors = _errs66;
if(vErrors !== null){
if(_errs66){
vErrors.length = _errs66;
}
else {
vErrors = null;
}
}
}
var valid15 = _errs65 === errors;
if(valid15){
const _errs69 = errors;
const _errs70 = errors;
const _errs71 = errors;
if(errors === _errs71){
if(data && typeof data == "object" && !Array.isArray(data)){
let missing10;
if((data.operation === undefined) && (missing10 = "operation")){
const err44 = {};
if(vErrors === null){
vErrors = [err44];
}
else {
vErrors.push(err44);
}
errors++;
}
}
else {
const err45 = {};
if(vErrors === null){
vErrors = [err45];
}
else {
vErrors.push(err45);
}
errors++;
}
}
var valid25 = _errs71 === errors;
if(valid25){
const err46 = {instancePath,schemaPath:"#/oneOf/2/allOf/6/not",keyword:"not",params:{},message:"must NOT be valid"};
if(vErrors === null){
vErrors = [err46];
}
else {
vErrors.push(err46);
}
errors++;
}
else {
errors = _errs70;
if(vErrors !== null){
if(_errs70){
vErrors.length = _errs70;
}
else {
vErrors = null;
}
}
}
var valid15 = _errs69 === errors;
if(valid15){
const _errs73 = errors;
const _errs74 = errors;
const _errs75 = errors;
if(errors === _errs75){
if(data && typeof data == "object" && !Array.isArray(data)){
let missing11;
if((data.secondValue === undefined) && (missing11 = "secondValue")){
const err47 = {};
if(vErrors === null){
vErrors = [err47];
}
else {
vErrors.push(err47);
}
errors++;
}
}
else {
const err48 = {};
if(vErrors === null){
vErrors = [err48];
}
else {
vErrors.push(err48);
}
errors++;
}
}
var valid26 = _errs75 === errors;
if(valid26){
const err49 = {instancePath,schemaPath:"#/oneOf/2/allOf/7/not",keyword:"not",params:{},message:"must NOT be valid"};
if(vErrors === null){
vErrors = [err49];
}
else {
vErrors.push(err49);
}
errors++;
}
else {
errors = _errs74;
if(vErrors !== null){
if(_errs74){
vErrors.length = _errs74;
}
else {
vErrors = null;
}
}
}
var valid15 = _errs73 === errors;
if(valid15){
const _errs77 = errors;
if(errors === _errs77){
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.children !== undefined){
let data6 = data.children;
const _errs79 = errors;
if(errors === _errs79){
if(Array.isArray(data6)){
if(data6.length < 2){
const err50 = {instancePath:instancePath+"/children",schemaPath:"#/oneOf/2/allOf/8/properties/children/minItems",keyword:"minItems",params:{limit: 2},message:"must NOT have fewer than 2 items"};
if(vErrors === null){
vErrors = [err50];
}
else {
vErrors.push(err50);
}
errors++;
}
}
else {
const err51 = {instancePath:instancePath+"/children",schemaPath:"#/oneOf/2/allOf/8/properties/children/type",keyword:"type",params:{type: "array"},message:"must be array"};
if(vErrors === null){
vErrors = [err51];
}
else {
vErrors.push(err51);
}
errors++;
}
}
}
}
else {
const err52 = {instancePath,schemaPath:"#/oneOf/2/allOf/8/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err52];
}
else {
vErrors.push(err52);
}
errors++;
}
}
var valid15 = _errs77 === errors;
}
}
}
}
}
}
}
}
var _valid0 = _errs42 === errors;
if(_valid0 && valid0){
valid0 = false;
passing0 = [passing0, 2];
}
else {
if(_valid0){
valid0 = true;
passing0 = 2;
}
}
}
if(!valid0){
const err53 = {instancePath,schemaPath:"#/oneOf",keyword:"oneOf",params:{passingSchemas: passing0},message:"must match exactly one schema in oneOf"};
if(vErrors === null){
vErrors = [err53];
}
else {
vErrors.push(err53);
}
errors++;
validate22.errors = vErrors;
return false;
}
else {
errors = _errs0;
if(vErrors !== null){
if(_errs0){
vErrors.length = _errs0;
}
else {
vErrors = null;
}
}
}
validate22.errors = vErrors;
return errors === 0;
}

const schema30 = {"oneOf":[{"not":{"$ref":"#/definitions/is-leaf"}},{"allOf":[{"$ref":"#/definitions/is-question-leaf"},{"type":"object","required":["leafType","questionLabel"]},{"oneOf":[{"allOf":[{"not":{"type":"object","required":["operation"]}},{"type":"object","required":["value"]}]},{"allOf":[{"$ref":"#/definitions/has-operation-answered"},{"not":{"type":"object","required":["value"]}}]}]},{"not":{"type":"object","required":["secondValue"]}},{"not":{"type":"object","required":["children"]}},{"$ref":"#/definitions/value-type-is-boolean-string"}]},{"allOf":[{"$ref":"#/definitions/is-leaf"},{"not":{"$ref":"#/definitions/is-question-leaf"}},{"type":"object","required":["leafType","questionLabel"]},{"oneOf":[{"allOf":[{"not":{"$ref":"#/definitions/has-operation-answered"}},{"type":"object","required":["value"]}]},{"allOf":[{"$ref":"#/definitions/has-operation-answered"},{"not":{"type":"object","required":["value"]}}]}]},{"not":{"type":"object","required":["children"]}},{"oneOf":[{"$ref":"#/definitions/has-leaftype-slider"},{"$ref":"#/definitions/has-leaftype-table"},{"$ref":"#/definitions/has-leaftype-text"},{"$ref":"#/definitions/has-leaftype-date"}]},{"oneOf":[{"allOf":[{"not":{"$ref":"#/definitions/has-operation-between"}},{"not":{"type":"object","required":["secondValue"]}}]},{"allOf":[{"$ref":"#/definitions/has-operation-between"},{"type":"object","required":["secondValue"]}]}]}]}]};
const schema32 = {"type":"object","properties":{"nodeType":{"enum":["leaf"]},"leafType":{"enum":["question"]}}};
const schema33 = {"type":"object","properties":{"operation":{"enum":["answered"]}}};
const schema34 = {"type":"object","properties":{"value":{"type":["string","boolean"]}}};
const schema39 = {"type":"object","properties":{"leafType":{"enum":["slider"]},"value":{"type":"number"},"secondValue":{"type":"number"}}};
const schema40 = {"type":"object","properties":{"leafType":{"enum":["table"]},"value":{"type":"number"},"secondValue":{"type":"number"}}};
const schema41 = {"type":"object","properties":{"leafType":{"enum":["text"]},"not":{"type":"object","required":["value","secondValue"]}}};
const schema42 = {"type":"object","properties":{"leafType":{"enum":["date"]},"value":{"type":"string"},"secondValue":{"type":"string"}}};
const schema43 = {"type":"object","properties":{"operation":{"enum":["between"]}}};

function validate24(data, {instancePath="", parentData, parentDataProperty, rootData=data}={}){
let vErrors = null;
let errors = 0;
const _errs0 = errors;
let valid0 = false;
let passing0 = null;
const _errs1 = errors;
const _errs2 = errors;
const _errs3 = errors;
const _errs4 = errors;
if(errors === _errs4){
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.nodeType !== undefined){
if(!(data.nodeType === "leaf")){
const err0 = {};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
}
}
else {
const err1 = {};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
}
var valid1 = _errs3 === errors;
if(valid1){
const err2 = {instancePath,schemaPath:"#/oneOf/0/not",keyword:"not",params:{},message:"must NOT be valid"};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
else {
errors = _errs2;
if(vErrors !== null){
if(_errs2){
vErrors.length = _errs2;
}
else {
vErrors = null;
}
}
}
var _valid0 = _errs1 === errors;
if(_valid0){
valid0 = true;
passing0 = 0;
}
const _errs7 = errors;
const _errs8 = errors;
const _errs9 = errors;
if(errors === _errs9){
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.nodeType !== undefined){
const _errs11 = errors;
if(!(data.nodeType === "leaf")){
const err3 = {instancePath:instancePath+"/nodeType",schemaPath:"#/definitions/is-question-leaf/properties/nodeType/enum",keyword:"enum",params:{allowedValues: schema32.properties.nodeType.enum},message:"must be equal to one of the allowed values"};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
var valid6 = _errs11 === errors;
}
else {
var valid6 = true;
}
if(valid6){
if(data.leafType !== undefined){
const _errs12 = errors;
if(!(data.leafType === "question")){
const err4 = {instancePath:instancePath+"/leafType",schemaPath:"#/definitions/is-question-leaf/properties/leafType/enum",keyword:"enum",params:{allowedValues: schema32.properties.leafType.enum},message:"must be equal to one of the allowed values"};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
var valid6 = _errs12 === errors;
}
else {
var valid6 = true;
}
}
}
else {
const err5 = {instancePath,schemaPath:"#/definitions/is-question-leaf/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
}
var valid4 = _errs8 === errors;
if(valid4){
const _errs13 = errors;
if(errors === _errs13){
if(data && typeof data == "object" && !Array.isArray(data)){
let missing0;
if(((data.leafType === undefined) && (missing0 = "leafType")) || ((data.questionLabel === undefined) && (missing0 = "questionLabel"))){
const err6 = {instancePath,schemaPath:"#/oneOf/1/allOf/1/required",keyword:"required",params:{missingProperty: missing0},message:"must have required property '"+missing0+"'"};
if(vErrors === null){
vErrors = [err6];
}
else {
vErrors.push(err6);
}
errors++;
}
}
else {
const err7 = {instancePath,schemaPath:"#/oneOf/1/allOf/1/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err7];
}
else {
vErrors.push(err7);
}
errors++;
}
}
var valid4 = _errs13 === errors;
if(valid4){
const _errs15 = errors;
const _errs16 = errors;
let valid7 = false;
let passing1 = null;
const _errs17 = errors;
const _errs18 = errors;
const _errs19 = errors;
const _errs20 = errors;
if(errors === _errs20){
if(data && typeof data == "object" && !Array.isArray(data)){
let missing1;
if((data.operation === undefined) && (missing1 = "operation")){
const err8 = {};
if(vErrors === null){
vErrors = [err8];
}
else {
vErrors.push(err8);
}
errors++;
}
}
else {
const err9 = {};
if(vErrors === null){
vErrors = [err9];
}
else {
vErrors.push(err9);
}
errors++;
}
}
var valid9 = _errs20 === errors;
if(valid9){
const err10 = {instancePath,schemaPath:"#/oneOf/1/allOf/2/oneOf/0/allOf/0/not",keyword:"not",params:{},message:"must NOT be valid"};
if(vErrors === null){
vErrors = [err10];
}
else {
vErrors.push(err10);
}
errors++;
}
else {
errors = _errs19;
if(vErrors !== null){
if(_errs19){
vErrors.length = _errs19;
}
else {
vErrors = null;
}
}
}
var valid8 = _errs18 === errors;
if(valid8){
const _errs22 = errors;
if(errors === _errs22){
if(data && typeof data == "object" && !Array.isArray(data)){
let missing2;
if((data.value === undefined) && (missing2 = "value")){
const err11 = {instancePath,schemaPath:"#/oneOf/1/allOf/2/oneOf/0/allOf/1/required",keyword:"required",params:{missingProperty: missing2},message:"must have required property '"+missing2+"'"};
if(vErrors === null){
vErrors = [err11];
}
else {
vErrors.push(err11);
}
errors++;
}
}
else {
const err12 = {instancePath,schemaPath:"#/oneOf/1/allOf/2/oneOf/0/allOf/1/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err12];
}
else {
vErrors.push(err12);
}
errors++;
}
}
var valid8 = _errs22 === errors;
}
var _valid1 = _errs17 === errors;
if(_valid1){
valid7 = true;
passing1 = 0;
}
const _errs24 = errors;
const _errs25 = errors;
const _errs26 = errors;
if(errors === _errs26){
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.operation !== undefined){
if(!(data.operation === "answered")){
const err13 = {instancePath:instancePath+"/operation",schemaPath:"#/definitions/has-operation-answered/properties/operation/enum",keyword:"enum",params:{allowedValues: schema33.properties.operation.enum},message:"must be equal to one of the allowed values"};
if(vErrors === null){
vErrors = [err13];
}
else {
vErrors.push(err13);
}
errors++;
}
}
}
else {
const err14 = {instancePath,schemaPath:"#/definitions/has-operation-answered/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err14];
}
else {
vErrors.push(err14);
}
errors++;
}
}
var valid10 = _errs25 === errors;
if(valid10){
const _errs29 = errors;
const _errs30 = errors;
const _errs31 = errors;
if(errors === _errs31){
if(data && typeof data == "object" && !Array.isArray(data)){
let missing3;
if((data.value === undefined) && (missing3 = "value")){
const err15 = {};
if(vErrors === null){
vErrors = [err15];
}
else {
vErrors.push(err15);
}
errors++;
}
}
else {
const err16 = {};
if(vErrors === null){
vErrors = [err16];
}
else {
vErrors.push(err16);
}
errors++;
}
}
var valid13 = _errs31 === errors;
if(valid13){
const err17 = {instancePath,schemaPath:"#/oneOf/1/allOf/2/oneOf/1/allOf/1/not",keyword:"not",params:{},message:"must NOT be valid"};
if(vErrors === null){
vErrors = [err17];
}
else {
vErrors.push(err17);
}
errors++;
}
else {
errors = _errs30;
if(vErrors !== null){
if(_errs30){
vErrors.length = _errs30;
}
else {
vErrors = null;
}
}
}
var valid10 = _errs29 === errors;
}
var _valid1 = _errs24 === errors;
if(_valid1 && valid7){
valid7 = false;
passing1 = [passing1, 1];
}
else {
if(_valid1){
valid7 = true;
passing1 = 1;
}
}
if(!valid7){
const err18 = {instancePath,schemaPath:"#/oneOf/1/allOf/2/oneOf",keyword:"oneOf",params:{passingSchemas: passing1},message:"must match exactly one schema in oneOf"};
if(vErrors === null){
vErrors = [err18];
}
else {
vErrors.push(err18);
}
errors++;
}
else {
errors = _errs16;
if(vErrors !== null){
if(_errs16){
vErrors.length = _errs16;
}
else {
vErrors = null;
}
}
}
var valid4 = _errs15 === errors;
if(valid4){
const _errs33 = errors;
const _errs34 = errors;
const _errs35 = errors;
if(errors === _errs35){
if(data && typeof data == "object" && !Array.isArray(data)){
let missing4;
if((data.secondValue === undefined) && (missing4 = "secondValue")){
const err19 = {};
if(vErrors === null){
vErrors = [err19];
}
else {
vErrors.push(err19);
}
errors++;
}
}
else {
const err20 = {};
if(vErrors === null){
vErrors = [err20];
}
else {
vErrors.push(err20);
}
errors++;
}
}
var valid14 = _errs35 === errors;
if(valid14){
const err21 = {instancePath,schemaPath:"#/oneOf/1/allOf/3/not",keyword:"not",params:{},message:"must NOT be valid"};
if(vErrors === null){
vErrors = [err21];
}
else {
vErrors.push(err21);
}
errors++;
}
else {
errors = _errs34;
if(vErrors !== null){
if(_errs34){
vErrors.length = _errs34;
}
else {
vErrors = null;
}
}
}
var valid4 = _errs33 === errors;
if(valid4){
const _errs37 = errors;
const _errs38 = errors;
const _errs39 = errors;
if(errors === _errs39){
if(data && typeof data == "object" && !Array.isArray(data)){
let missing5;
if((data.children === undefined) && (missing5 = "children")){
const err22 = {};
if(vErrors === null){
vErrors = [err22];
}
else {
vErrors.push(err22);
}
errors++;
}
}
else {
const err23 = {};
if(vErrors === null){
vErrors = [err23];
}
else {
vErrors.push(err23);
}
errors++;
}
}
var valid15 = _errs39 === errors;
if(valid15){
const err24 = {instancePath,schemaPath:"#/oneOf/1/allOf/4/not",keyword:"not",params:{},message:"must NOT be valid"};
if(vErrors === null){
vErrors = [err24];
}
else {
vErrors.push(err24);
}
errors++;
}
else {
errors = _errs38;
if(vErrors !== null){
if(_errs38){
vErrors.length = _errs38;
}
else {
vErrors = null;
}
}
}
var valid4 = _errs37 === errors;
if(valid4){
const _errs41 = errors;
const _errs42 = errors;
if(errors === _errs42){
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.value !== undefined){
let data4 = data.value;
if((typeof data4 !== "string") && (typeof data4 !== "boolean")){
const err25 = {instancePath:instancePath+"/value",schemaPath:"#/definitions/value-type-is-boolean-string/properties/value/type",keyword:"type",params:{type: schema34.properties.value.type},message:"must be string,boolean"};
if(vErrors === null){
vErrors = [err25];
}
else {
vErrors.push(err25);
}
errors++;
}
}
}
else {
const err26 = {instancePath,schemaPath:"#/definitions/value-type-is-boolean-string/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err26];
}
else {
vErrors.push(err26);
}
errors++;
}
}
var valid4 = _errs41 === errors;
}
}
}
}
}
var _valid0 = _errs7 === errors;
if(_valid0 && valid0){
valid0 = false;
passing0 = [passing0, 1];
}
else {
if(_valid0){
valid0 = true;
passing0 = 1;
}
const _errs46 = errors;
const _errs47 = errors;
const _errs48 = errors;
if(errors === _errs48){
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.nodeType !== undefined){
if(!(data.nodeType === "leaf")){
const err27 = {instancePath:instancePath+"/nodeType",schemaPath:"#/definitions/is-leaf/properties/nodeType/enum",keyword:"enum",params:{allowedValues: schema25.properties.nodeType.enum},message:"must be equal to one of the allowed values"};
if(vErrors === null){
vErrors = [err27];
}
else {
vErrors.push(err27);
}
errors++;
}
}
}
else {
const err28 = {instancePath,schemaPath:"#/definitions/is-leaf/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err28];
}
else {
vErrors.push(err28);
}
errors++;
}
}
var valid18 = _errs47 === errors;
if(valid18){
const _errs51 = errors;
const _errs52 = errors;
const _errs53 = errors;
const _errs54 = errors;
if(errors === _errs54){
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.nodeType !== undefined){
const _errs56 = errors;
if(!(data.nodeType === "leaf")){
const err29 = {};
if(vErrors === null){
vErrors = [err29];
}
else {
vErrors.push(err29);
}
errors++;
}
var valid23 = _errs56 === errors;
}
else {
var valid23 = true;
}
if(valid23){
if(data.leafType !== undefined){
const _errs57 = errors;
if(!(data.leafType === "question")){
const err30 = {};
if(vErrors === null){
vErrors = [err30];
}
else {
vErrors.push(err30);
}
errors++;
}
var valid23 = _errs57 === errors;
}
else {
var valid23 = true;
}
}
}
else {
const err31 = {};
if(vErrors === null){
vErrors = [err31];
}
else {
vErrors.push(err31);
}
errors++;
}
}
var valid21 = _errs53 === errors;
if(valid21){
const err32 = {instancePath,schemaPath:"#/oneOf/2/allOf/1/not",keyword:"not",params:{},message:"must NOT be valid"};
if(vErrors === null){
vErrors = [err32];
}
else {
vErrors.push(err32);
}
errors++;
}
else {
errors = _errs52;
if(vErrors !== null){
if(_errs52){
vErrors.length = _errs52;
}
else {
vErrors = null;
}
}
}
var valid18 = _errs51 === errors;
if(valid18){
const _errs58 = errors;
if(errors === _errs58){
if(data && typeof data == "object" && !Array.isArray(data)){
let missing6;
if(((data.leafType === undefined) && (missing6 = "leafType")) || ((data.questionLabel === undefined) && (missing6 = "questionLabel"))){
const err33 = {instancePath,schemaPath:"#/oneOf/2/allOf/2/required",keyword:"required",params:{missingProperty: missing6},message:"must have required property '"+missing6+"'"};
if(vErrors === null){
vErrors = [err33];
}
else {
vErrors.push(err33);
}
errors++;
}
}
else {
const err34 = {instancePath,schemaPath:"#/oneOf/2/allOf/2/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err34];
}
else {
vErrors.push(err34);
}
errors++;
}
}
var valid18 = _errs58 === errors;
if(valid18){
const _errs60 = errors;
const _errs61 = errors;
let valid24 = false;
let passing2 = null;
const _errs62 = errors;
const _errs63 = errors;
const _errs64 = errors;
const _errs65 = errors;
const _errs66 = errors;
if(errors === _errs66){
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.operation !== undefined){
if(!(data.operation === "answered")){
const err35 = {};
if(vErrors === null){
vErrors = [err35];
}
else {
vErrors.push(err35);
}
errors++;
}
}
}
else {
const err36 = {};
if(vErrors === null){
vErrors = [err36];
}
else {
vErrors.push(err36);
}
errors++;
}
}
var valid26 = _errs65 === errors;
if(valid26){
const err37 = {instancePath,schemaPath:"#/oneOf/2/allOf/3/oneOf/0/allOf/0/not",keyword:"not",params:{},message:"must NOT be valid"};
if(vErrors === null){
vErrors = [err37];
}
else {
vErrors.push(err37);
}
errors++;
}
else {
errors = _errs64;
if(vErrors !== null){
if(_errs64){
vErrors.length = _errs64;
}
else {
vErrors = null;
}
}
}
var valid25 = _errs63 === errors;
if(valid25){
const _errs69 = errors;
if(errors === _errs69){
if(data && typeof data == "object" && !Array.isArray(data)){
let missing7;
if((data.value === undefined) && (missing7 = "value")){
const err38 = {instancePath,schemaPath:"#/oneOf/2/allOf/3/oneOf/0/allOf/1/required",keyword:"required",params:{missingProperty: missing7},message:"must have required property '"+missing7+"'"};
if(vErrors === null){
vErrors = [err38];
}
else {
vErrors.push(err38);
}
errors++;
}
}
else {
const err39 = {instancePath,schemaPath:"#/oneOf/2/allOf/3/oneOf/0/allOf/1/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err39];
}
else {
vErrors.push(err39);
}
errors++;
}
}
var valid25 = _errs69 === errors;
}
var _valid2 = _errs62 === errors;
if(_valid2){
valid24 = true;
passing2 = 0;
}
const _errs71 = errors;
const _errs72 = errors;
const _errs73 = errors;
if(errors === _errs73){
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.operation !== undefined){
if(!(data.operation === "answered")){
const err40 = {instancePath:instancePath+"/operation",schemaPath:"#/definitions/has-operation-answered/properties/operation/enum",keyword:"enum",params:{allowedValues: schema33.properties.operation.enum},message:"must be equal to one of the allowed values"};
if(vErrors === null){
vErrors = [err40];
}
else {
vErrors.push(err40);
}
errors++;
}
}
}
else {
const err41 = {instancePath,schemaPath:"#/definitions/has-operation-answered/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err41];
}
else {
vErrors.push(err41);
}
errors++;
}
}
var valid29 = _errs72 === errors;
if(valid29){
const _errs76 = errors;
const _errs77 = errors;
const _errs78 = errors;
if(errors === _errs78){
if(data && typeof data == "object" && !Array.isArray(data)){
let missing8;
if((data.value === undefined) && (missing8 = "value")){
const err42 = {};
if(vErrors === null){
vErrors = [err42];
}
else {
vErrors.push(err42);
}
errors++;
}
}
else {
const err43 = {};
if(vErrors === null){
vErrors = [err43];
}
else {
vErrors.push(err43);
}
errors++;
}
}
var valid32 = _errs78 === errors;
if(valid32){
const err44 = {instancePath,schemaPath:"#/oneOf/2/allOf/3/oneOf/1/allOf/1/not",keyword:"not",params:{},message:"must NOT be valid"};
if(vErrors === null){
vErrors = [err44];
}
else {
vErrors.push(err44);
}
errors++;
}
else {
errors = _errs77;
if(vErrors !== null){
if(_errs77){
vErrors.length = _errs77;
}
else {
vErrors = null;
}
}
}
var valid29 = _errs76 === errors;
}
var _valid2 = _errs71 === errors;
if(_valid2 && valid24){
valid24 = false;
passing2 = [passing2, 1];
}
else {
if(_valid2){
valid24 = true;
passing2 = 1;
}
}
if(!valid24){
const err45 = {instancePath,schemaPath:"#/oneOf/2/allOf/3/oneOf",keyword:"oneOf",params:{passingSchemas: passing2},message:"must match exactly one schema in oneOf"};
if(vErrors === null){
vErrors = [err45];
}
else {
vErrors.push(err45);
}
errors++;
}
else {
errors = _errs61;
if(vErrors !== null){
if(_errs61){
vErrors.length = _errs61;
}
else {
vErrors = null;
}
}
}
var valid18 = _errs60 === errors;
if(valid18){
const _errs80 = errors;
const _errs81 = errors;
const _errs82 = errors;
if(errors === _errs82){
if(data && typeof data == "object" && !Array.isArray(data)){
let missing9;
if((data.children === undefined) && (missing9 = "children")){
const err46 = {};
if(vErrors === null){
vErrors = [err46];
}
else {
vErrors.push(err46);
}
errors++;
}
}
else {
const err47 = {};
if(vErrors === null){
vErrors = [err47];
}
else {
vErrors.push(err47);
}
errors++;
}
}
var valid33 = _errs82 === errors;
if(valid33){
const err48 = {instancePath,schemaPath:"#/oneOf/2/allOf/4/not",keyword:"not",params:{},message:"must NOT be valid"};
if(vErrors === null){
vErrors = [err48];
}
else {
vErrors.push(err48);
}
errors++;
}
else {
errors = _errs81;
if(vErrors !== null){
if(_errs81){
vErrors.length = _errs81;
}
else {
vErrors = null;
}
}
}
var valid18 = _errs80 === errors;
if(valid18){
const _errs84 = errors;
const _errs85 = errors;
let valid34 = false;
let passing3 = null;
const _errs86 = errors;
const _errs87 = errors;
if(errors === _errs87){
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.leafType !== undefined){
const _errs89 = errors;
if(!(data.leafType === "slider")){
const err49 = {instancePath:instancePath+"/leafType",schemaPath:"#/definitions/has-leaftype-slider/properties/leafType/enum",keyword:"enum",params:{allowedValues: schema39.properties.leafType.enum},message:"must be equal to one of the allowed values"};
if(vErrors === null){
vErrors = [err49];
}
else {
vErrors.push(err49);
}
errors++;
}
var valid36 = _errs89 === errors;
}
else {
var valid36 = true;
}
if(valid36){
if(data.value !== undefined){
let data11 = data.value;
const _errs90 = errors;
if(!((typeof data11 == "number") && (isFinite(data11)))){
const err50 = {instancePath:instancePath+"/value",schemaPath:"#/definitions/has-leaftype-slider/properties/value/type",keyword:"type",params:{type: "number"},message:"must be number"};
if(vErrors === null){
vErrors = [err50];
}
else {
vErrors.push(err50);
}
errors++;
}
var valid36 = _errs90 === errors;
}
else {
var valid36 = true;
}
if(valid36){
if(data.secondValue !== undefined){
let data12 = data.secondValue;
const _errs92 = errors;
if(!((typeof data12 == "number") && (isFinite(data12)))){
const err51 = {instancePath:instancePath+"/secondValue",schemaPath:"#/definitions/has-leaftype-slider/properties/secondValue/type",keyword:"type",params:{type: "number"},message:"must be number"};
if(vErrors === null){
vErrors = [err51];
}
else {
vErrors.push(err51);
}
errors++;
}
var valid36 = _errs92 === errors;
}
else {
var valid36 = true;
}
}
}
}
else {
const err52 = {instancePath,schemaPath:"#/definitions/has-leaftype-slider/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err52];
}
else {
vErrors.push(err52);
}
errors++;
}
}
var _valid3 = _errs86 === errors;
if(_valid3){
valid34 = true;
passing3 = 0;
}
const _errs94 = errors;
const _errs95 = errors;
if(errors === _errs95){
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.leafType !== undefined){
const _errs97 = errors;
if(!(data.leafType === "table")){
const err53 = {instancePath:instancePath+"/leafType",schemaPath:"#/definitions/has-leaftype-table/properties/leafType/enum",keyword:"enum",params:{allowedValues: schema40.properties.leafType.enum},message:"must be equal to one of the allowed values"};
if(vErrors === null){
vErrors = [err53];
}
else {
vErrors.push(err53);
}
errors++;
}
var valid38 = _errs97 === errors;
}
else {
var valid38 = true;
}
if(valid38){
if(data.value !== undefined){
let data14 = data.value;
const _errs98 = errors;
if(!((typeof data14 == "number") && (isFinite(data14)))){
const err54 = {instancePath:instancePath+"/value",schemaPath:"#/definitions/has-leaftype-table/properties/value/type",keyword:"type",params:{type: "number"},message:"must be number"};
if(vErrors === null){
vErrors = [err54];
}
else {
vErrors.push(err54);
}
errors++;
}
var valid38 = _errs98 === errors;
}
else {
var valid38 = true;
}
if(valid38){
if(data.secondValue !== undefined){
let data15 = data.secondValue;
const _errs100 = errors;
if(!((typeof data15 == "number") && (isFinite(data15)))){
const err55 = {instancePath:instancePath+"/secondValue",schemaPath:"#/definitions/has-leaftype-table/properties/secondValue/type",keyword:"type",params:{type: "number"},message:"must be number"};
if(vErrors === null){
vErrors = [err55];
}
else {
vErrors.push(err55);
}
errors++;
}
var valid38 = _errs100 === errors;
}
else {
var valid38 = true;
}
}
}
}
else {
const err56 = {instancePath,schemaPath:"#/definitions/has-leaftype-table/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err56];
}
else {
vErrors.push(err56);
}
errors++;
}
}
var _valid3 = _errs94 === errors;
if(_valid3 && valid34){
valid34 = false;
passing3 = [passing3, 1];
}
else {
if(_valid3){
valid34 = true;
passing3 = 1;
}
const _errs102 = errors;
const _errs103 = errors;
if(errors === _errs103){
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.leafType !== undefined){
const _errs105 = errors;
if(!(data.leafType === "text")){
const err57 = {instancePath:instancePath+"/leafType",schemaPath:"#/definitions/has-leaftype-text/properties/leafType/enum",keyword:"enum",params:{allowedValues: schema41.properties.leafType.enum},message:"must be equal to one of the allowed values"};
if(vErrors === null){
vErrors = [err57];
}
else {
vErrors.push(err57);
}
errors++;
}
var valid40 = _errs105 === errors;
}
else {
var valid40 = true;
}
if(valid40){
if(data.not !== undefined){
let data17 = data.not;
const _errs106 = errors;
if(errors === _errs106){
if(data17 && typeof data17 == "object" && !Array.isArray(data17)){
let missing10;
if(((data17.value === undefined) && (missing10 = "value")) || ((data17.secondValue === undefined) && (missing10 = "secondValue"))){
const err58 = {instancePath:instancePath+"/not",schemaPath:"#/definitions/has-leaftype-text/properties/not/required",keyword:"required",params:{missingProperty: missing10},message:"must have required property '"+missing10+"'"};
if(vErrors === null){
vErrors = [err58];
}
else {
vErrors.push(err58);
}
errors++;
}
}
else {
const err59 = {instancePath:instancePath+"/not",schemaPath:"#/definitions/has-leaftype-text/properties/not/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err59];
}
else {
vErrors.push(err59);
}
errors++;
}
}
var valid40 = _errs106 === errors;
}
else {
var valid40 = true;
}
}
}
else {
const err60 = {instancePath,schemaPath:"#/definitions/has-leaftype-text/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err60];
}
else {
vErrors.push(err60);
}
errors++;
}
}
var _valid3 = _errs102 === errors;
if(_valid3 && valid34){
valid34 = false;
passing3 = [passing3, 2];
}
else {
if(_valid3){
valid34 = true;
passing3 = 2;
}
const _errs108 = errors;
const _errs109 = errors;
if(errors === _errs109){
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.leafType !== undefined){
const _errs111 = errors;
if(!(data.leafType === "date")){
const err61 = {instancePath:instancePath+"/leafType",schemaPath:"#/definitions/has-leaftype-date/properties/leafType/enum",keyword:"enum",params:{allowedValues: schema42.properties.leafType.enum},message:"must be equal to one of the allowed values"};
if(vErrors === null){
vErrors = [err61];
}
else {
vErrors.push(err61);
}
errors++;
}
var valid42 = _errs111 === errors;
}
else {
var valid42 = true;
}
if(valid42){
if(data.value !== undefined){
const _errs112 = errors;
if(typeof data.value !== "string"){
const err62 = {instancePath:instancePath+"/value",schemaPath:"#/definitions/has-leaftype-date/properties/value/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err62];
}
else {
vErrors.push(err62);
}
errors++;
}
var valid42 = _errs112 === errors;
}
else {
var valid42 = true;
}
if(valid42){
if(data.secondValue !== undefined){
const _errs114 = errors;
if(typeof data.secondValue !== "string"){
const err63 = {instancePath:instancePath+"/secondValue",schemaPath:"#/definitions/has-leaftype-date/properties/secondValue/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err63];
}
else {
vErrors.push(err63);
}
errors++;
}
var valid42 = _errs114 === errors;
}
else {
var valid42 = true;
}
}
}
}
else {
const err64 = {instancePath,schemaPath:"#/definitions/has-leaftype-date/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err64];
}
else {
vErrors.push(err64);
}
errors++;
}
}
var _valid3 = _errs108 === errors;
if(_valid3 && valid34){
valid34 = false;
passing3 = [passing3, 3];
}
else {
if(_valid3){
valid34 = true;
passing3 = 3;
}
}
}
}
if(!valid34){
const err65 = {instancePath,schemaPath:"#/oneOf/2/allOf/5/oneOf",keyword:"oneOf",params:{passingSchemas: passing3},message:"must match exactly one schema in oneOf"};
if(vErrors === null){
vErrors = [err65];
}
else {
vErrors.push(err65);
}
errors++;
}
else {
errors = _errs85;
if(vErrors !== null){
if(_errs85){
vErrors.length = _errs85;
}
else {
vErrors = null;
}
}
}
var valid18 = _errs84 === errors;
if(valid18){
const _errs116 = errors;
const _errs117 = errors;
let valid43 = false;
let passing4 = null;
const _errs118 = errors;
const _errs119 = errors;
const _errs120 = errors;
const _errs121 = errors;
const _errs122 = errors;
if(errors === _errs122){
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.operation !== undefined){
if(!(data.operation === "between")){
const err66 = {};
if(vErrors === null){
vErrors = [err66];
}
else {
vErrors.push(err66);
}
errors++;
}
}
}
else {
const err67 = {};
if(vErrors === null){
vErrors = [err67];
}
else {
vErrors.push(err67);
}
errors++;
}
}
var valid45 = _errs121 === errors;
if(valid45){
const err68 = {instancePath,schemaPath:"#/oneOf/2/allOf/6/oneOf/0/allOf/0/not",keyword:"not",params:{},message:"must NOT be valid"};
if(vErrors === null){
vErrors = [err68];
}
else {
vErrors.push(err68);
}
errors++;
}
else {
errors = _errs120;
if(vErrors !== null){
if(_errs120){
vErrors.length = _errs120;
}
else {
vErrors = null;
}
}
}
var valid44 = _errs119 === errors;
if(valid44){
const _errs125 = errors;
const _errs126 = errors;
const _errs127 = errors;
if(errors === _errs127){
if(data && typeof data == "object" && !Array.isArray(data)){
let missing11;
if((data.secondValue === undefined) && (missing11 = "secondValue")){
const err69 = {};
if(vErrors === null){
vErrors = [err69];
}
else {
vErrors.push(err69);
}
errors++;
}
}
else {
const err70 = {};
if(vErrors === null){
vErrors = [err70];
}
else {
vErrors.push(err70);
}
errors++;
}
}
var valid48 = _errs127 === errors;
if(valid48){
const err71 = {instancePath,schemaPath:"#/oneOf/2/allOf/6/oneOf/0/allOf/1/not",keyword:"not",params:{},message:"must NOT be valid"};
if(vErrors === null){
vErrors = [err71];
}
else {
vErrors.push(err71);
}
errors++;
}
else {
errors = _errs126;
if(vErrors !== null){
if(_errs126){
vErrors.length = _errs126;
}
else {
vErrors = null;
}
}
}
var valid44 = _errs125 === errors;
}
var _valid4 = _errs118 === errors;
if(_valid4){
valid43 = true;
passing4 = 0;
}
const _errs129 = errors;
const _errs130 = errors;
const _errs131 = errors;
if(errors === _errs131){
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.operation !== undefined){
if(!(data.operation === "between")){
const err72 = {instancePath:instancePath+"/operation",schemaPath:"#/definitions/has-operation-between/properties/operation/enum",keyword:"enum",params:{allowedValues: schema43.properties.operation.enum},message:"must be equal to one of the allowed values"};
if(vErrors === null){
vErrors = [err72];
}
else {
vErrors.push(err72);
}
errors++;
}
}
}
else {
const err73 = {instancePath,schemaPath:"#/definitions/has-operation-between/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err73];
}
else {
vErrors.push(err73);
}
errors++;
}
}
var valid49 = _errs130 === errors;
if(valid49){
const _errs134 = errors;
if(errors === _errs134){
if(data && typeof data == "object" && !Array.isArray(data)){
let missing12;
if((data.secondValue === undefined) && (missing12 = "secondValue")){
const err74 = {instancePath,schemaPath:"#/oneOf/2/allOf/6/oneOf/1/allOf/1/required",keyword:"required",params:{missingProperty: missing12},message:"must have required property '"+missing12+"'"};
if(vErrors === null){
vErrors = [err74];
}
else {
vErrors.push(err74);
}
errors++;
}
}
else {
const err75 = {instancePath,schemaPath:"#/oneOf/2/allOf/6/oneOf/1/allOf/1/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err75];
}
else {
vErrors.push(err75);
}
errors++;
}
}
var valid49 = _errs134 === errors;
}
var _valid4 = _errs129 === errors;
if(_valid4 && valid43){
valid43 = false;
passing4 = [passing4, 1];
}
else {
if(_valid4){
valid43 = true;
passing4 = 1;
}
}
if(!valid43){
const err76 = {instancePath,schemaPath:"#/oneOf/2/allOf/6/oneOf",keyword:"oneOf",params:{passingSchemas: passing4},message:"must match exactly one schema in oneOf"};
if(vErrors === null){
vErrors = [err76];
}
else {
vErrors.push(err76);
}
errors++;
}
else {
errors = _errs117;
if(vErrors !== null){
if(_errs117){
vErrors.length = _errs117;
}
else {
vErrors = null;
}
}
}
var valid18 = _errs116 === errors;
}
}
}
}
}
}
var _valid0 = _errs46 === errors;
if(_valid0 && valid0){
valid0 = false;
passing0 = [passing0, 2];
}
else {
if(_valid0){
valid0 = true;
passing0 = 2;
}
}
}
if(!valid0){
const err77 = {instancePath,schemaPath:"#/oneOf",keyword:"oneOf",params:{passingSchemas: passing0},message:"must match exactly one schema in oneOf"};
if(vErrors === null){
vErrors = [err77];
}
else {
vErrors.push(err77);
}
errors++;
validate24.errors = vErrors;
return false;
}
else {
errors = _errs0;
if(vErrors !== null){
if(_errs0){
vErrors.length = _errs0;
}
else {
vErrors = null;
}
}
}
validate24.errors = vErrors;
return errors === 0;
}

const wrapper0 = {validate: validate21};

function validate21(data, {instancePath="", parentData, parentDataProperty, rootData=data}={}){
let vErrors = null;
let errors = 0;
const _errs1 = errors;
if(!(validate22(data, {instancePath,parentData,parentDataProperty,rootData}))){
vErrors = vErrors === null ? validate22.errors : vErrors.concat(validate22.errors);
errors = vErrors.length;
}
var valid0 = _errs1 === errors;
if(valid0){
const _errs2 = errors;
if(!(validate24(data, {instancePath,parentData,parentDataProperty,rootData}))){
vErrors = vErrors === null ? validate24.errors : vErrors.concat(validate24.errors);
errors = vErrors.length;
}
var valid0 = _errs2 === errors;
}
if(errors === 0){
if(data && typeof data == "object" && !Array.isArray(data)){
let missing0;
if((data.nodeType === undefined) && (missing0 = "nodeType")){
validate21.errors = [{instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: missing0},message:"must have required property '"+missing0+"'"}];
return false;
}
else {
const _errs3 = errors;
for(const key0 in data){
if(!(((((((key0 === "nodeType") || (key0 === "children")) || (key0 === "leafType")) || (key0 === "questionLabel")) || (key0 === "value")) || (key0 === "operation")) || (key0 === "secondValue"))){
validate21.errors = [{instancePath,schemaPath:"#/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key0},message:"must NOT have additional properties"}];
return false;
break;
}
}
if(_errs3 === errors){
if(data.nodeType !== undefined){
let data0 = data.nodeType;
const _errs4 = errors;
if(typeof data0 !== "string"){
validate21.errors = [{instancePath:instancePath+"/nodeType",schemaPath:"#/properties/nodeType/type",keyword:"type",params:{type: "string"},message:"must be string"}];
return false;
}
if(!((((data0 === "and") || (data0 === "or")) || (data0 === "not")) || (data0 === "leaf"))){
validate21.errors = [{instancePath:instancePath+"/nodeType",schemaPath:"#/properties/nodeType/enum",keyword:"enum",params:{allowedValues: schema23.properties.nodeType.enum},message:"must be equal to one of the allowed values"}];
return false;
}
var valid1 = _errs4 === errors;
}
else {
var valid1 = true;
}
if(valid1){
if(data.children !== undefined){
let data1 = data.children;
const _errs6 = errors;
if(errors === _errs6){
if(Array.isArray(data1)){
if(data1.length < 1){
validate21.errors = [{instancePath:instancePath+"/children",schemaPath:"#/properties/children/minItems",keyword:"minItems",params:{limit: 1},message:"must NOT have fewer than 1 items"}];
return false;
}
else {
var valid2 = true;
const len0 = data1.length;
for(let i0=0; i0<len0; i0++){
const _errs8 = errors;
if(!(wrapper0.validate(data1[i0], {instancePath:instancePath+"/children/" + i0,parentData:data1,parentDataProperty:i0,rootData}))){
vErrors = vErrors === null ? wrapper0.validate.errors : vErrors.concat(wrapper0.validate.errors);
errors = vErrors.length;
}
var valid2 = _errs8 === errors;
if(!valid2){
break;
}
}
}
}
else {
validate21.errors = [{instancePath:instancePath+"/children",schemaPath:"#/properties/children/type",keyword:"type",params:{type: "array"},message:"must be array"}];
return false;
}
}
var valid1 = _errs6 === errors;
}
else {
var valid1 = true;
}
if(valid1){
if(data.leafType !== undefined){
let data3 = data.leafType;
const _errs9 = errors;
if(typeof data3 !== "string"){
validate21.errors = [{instancePath:instancePath+"/leafType",schemaPath:"#/properties/leafType/type",keyword:"type",params:{type: "string"},message:"must be string"}];
return false;
}
if(!(((((data3 === "question") || (data3 === "slider")) || (data3 === "date")) || (data3 === "text")) || (data3 === "table"))){
validate21.errors = [{instancePath:instancePath+"/leafType",schemaPath:"#/properties/leafType/enum",keyword:"enum",params:{allowedValues: schema23.properties.leafType.enum},message:"must be equal to one of the allowed values"}];
return false;
}
var valid1 = _errs9 === errors;
}
else {
var valid1 = true;
}
if(valid1){
if(data.questionLabel !== undefined){
const _errs11 = errors;
if(typeof data.questionLabel !== "string"){
validate21.errors = [{instancePath:instancePath+"/questionLabel",schemaPath:"#/properties/questionLabel/type",keyword:"type",params:{type: "string"},message:"must be string"}];
return false;
}
var valid1 = _errs11 === errors;
}
else {
var valid1 = true;
}
if(valid1){
if(data.value !== undefined){
let data5 = data.value;
const _errs13 = errors;
if(((!((typeof data5 == "number") && (isFinite(data5)))) && (typeof data5 !== "string")) && (typeof data5 !== "boolean")){
validate21.errors = [{instancePath:instancePath+"/value",schemaPath:"#/properties/value/type",keyword:"type",params:{type: schema23.properties.value.type},message:"must be number,string,boolean"}];
return false;
}
var valid1 = _errs13 === errors;
}
else {
var valid1 = true;
}
if(valid1){
if(data.operation !== undefined){
let data6 = data.operation;
const _errs15 = errors;
if(typeof data6 !== "string"){
validate21.errors = [{instancePath:instancePath+"/operation",schemaPath:"#/properties/operation/type",keyword:"type",params:{type: "string"},message:"must be string"}];
return false;
}
if(!((((((((data6 === "less") || (data6 === "lessEqual")) || (data6 === "greater")) || (data6 === "greaterEqual")) || (data6 === "equals")) || (data6 === "notEquals")) || (data6 === "between")) || (data6 === "answered"))){
validate21.errors = [{instancePath:instancePath+"/operation",schemaPath:"#/properties/operation/enum",keyword:"enum",params:{allowedValues: schema23.properties.operation.enum},message:"must be equal to one of the allowed values"}];
return false;
}
var valid1 = _errs15 === errors;
}
else {
var valid1 = true;
}
if(valid1){
if(data.secondValue !== undefined){
let data7 = data.secondValue;
const _errs17 = errors;
if((!((typeof data7 == "number") && (isFinite(data7)))) && (typeof data7 !== "string")){
validate21.errors = [{instancePath:instancePath+"/secondValue",schemaPath:"#/properties/secondValue/type",keyword:"type",params:{type: schema23.properties.secondValue.type},message:"must be number,string"}];
return false;
}
var valid1 = _errs17 === errors;
}
else {
var valid1 = true;
}
}
}
}
}
}
}
}
}
}
else {
validate21.errors = [{instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object"}];
return false;
}
}
validate21.errors = vErrors;
return errors === 0;
}


function validate20(data, {instancePath="", parentData, parentDataProperty, rootData=data}={}){
/*# sourceURL="validateComplete" */;
let vErrors = null;
let errors = 0;
if(errors === 0){
if(data && typeof data == "object" && !Array.isArray(data)){
let missing0;
if((data.condition === undefined) && (missing0 = "condition")){
validate20.errors = [{instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: missing0},message:"must have required property '"+missing0+"'"}];
return false;
}
else {
const _errs1 = errors;
for(const key0 in data){
if(!(key0 === "condition")){
validate20.errors = [{instancePath,schemaPath:"#/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key0},message:"must NOT have additional properties"}];
return false;
break;
}
}
if(_errs1 === errors){
if(data.condition !== undefined){
if(!(validate21(data.condition, {instancePath:instancePath+"/condition",parentData:data,parentDataProperty:"condition",rootData}))){
vErrors = vErrors === null ? validate21.errors : vErrors.concat(validate21.errors);
errors = vErrors.length;
}
}
}
}
}
else {
validate20.errors = [{instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object"}];
return false;
}
}
validate20.errors = vErrors;
return errors === 0;
}

exports.validateSimplified = validate27;
const schema45 = {"$id":"validateSimplified","$schema":"http://json-schema.org/draft-07/schema#","definitions":{"condition":{"type":"object","properties":{"nodeType":{"type":"string","enum":["and","or","not","leaf"]},"children":{"type":"array","items":{"$ref":"#/definitions/condition"}},"leafType":{"type":"string","enum":["question","slider","date","text","table"]},"questionLabel":{"type":"string"},"value":{"type":["number","string","boolean"]},"operation":{"anyOf":[{"type":"string","enum":["less","lessEqual","greater","greaterEqual","equals","notEquals","between","answered"]},{"type":"string","maxLength":0}]},"secondValue":{"type":["number","string"]}},"required":["nodeType"],"additionalProperties":false,"allOf":[{"$ref":"#/definitions/and-or-not-require-children"},{"$ref":"#/definitions/leaf-requires-leafattributes"}]},"and-or-not-require-children":{"oneOf":[{"$ref":"#/definitions/is-leaf"},{"allOf":[{"not":{"$ref":"#/definitions/is-leaf"}},{"$ref":"#/definitions/is-not"},{"type":"object","required":["children"]},{"not":{"type":"object","required":["leafType"]}},{"not":{"type":"object","required":["questionLabel"]}},{"not":{"type":"object","required":["value"]}},{"not":{"type":"object","required":["operation"]}},{"not":{"type":"object","required":["secondValue"]}},{"type":"object","properties":{"children":{"type":"array","maxItems":1}}}]},{"allOf":[{"not":{"$ref":"#/definitions/is-leaf"}},{"not":{"$ref":"#/definitions/is-not"}},{"type":"object","required":["children"]},{"not":{"type":"object","required":["leafType"]}},{"not":{"type":"object","required":["questionLabel"]}},{"not":{"type":"object","required":["value"]}},{"not":{"type":"object","required":["operation"]}},{"not":{"type":"object","required":["secondValue"]}}]}]},"leaf-requires-leafattributes":{"oneOf":[{"not":{"$ref":"#/definitions/is-leaf"}},{"allOf":[{"$ref":"#/definitions/is-question-leaf"},{"type":"object","required":["leafType","questionLabel"]},{"oneOf":[{"allOf":[{"not":{"type":"object","required":["operation"]}},{"type":"object","required":["value"]}]},{"allOf":[{"$ref":"#/definitions/has-operation-answered"},{"not":{"type":"object","required":["value"]}}]}]},{"not":{"type":"object","required":["secondValue"]}},{"not":{"type":"object","required":["children"]}},{"$ref":"#/definitions/value-type-is-boolean-string"}]},{"allOf":[{"$ref":"#/definitions/is-leaf"},{"not":{"$ref":"#/definitions/is-question-leaf"}},{"type":"object","required":["leafType","questionLabel"]},{"oneOf":[{"allOf":[{"not":{"$ref":"#/definitions/has-operation-answered"}},{"type":"object","required":["value"]}]},{"allOf":[{"$ref":"#/definitions/has-operation-answered"},{"not":{"type":"object","required":["value"]}}]}]},{"not":{"type":"object","required":["children"]}},{"oneOf":[{"$ref":"#/definitions/has-leaftype-slider"},{"$ref":"#/definitions/has-leaftype-table"},{"$ref":"#/definitions/has-leaftype-text"},{"$ref":"#/definitions/has-leaftype-date"}]},{"oneOf":[{"allOf":[{"not":{"$ref":"#/definitions/has-operation-between"}},{"not":{"type":"object","required":["secondValue"]}}]},{"allOf":[{"$ref":"#/definitions/has-operation-between"},{"type":"object","required":["secondValue"]}]}]}]}]},"is-leaf":{"type":"object","properties":{"nodeType":{"enum":["leaf"]}}},"is-not":{"type":"object","properties":{"nodeType":{"enum":["not"]}}},"is-question-leaf":{"type":"object","properties":{"nodeType":{"enum":["leaf"]},"leafType":{"enum":["question"]}}},"has-leaftype-slider":{"type":"object","properties":{"leafType":{"enum":["slider"]},"value":{"type":["number","string"]},"secondValue":{"type":["number","string"]}}},"has-leaftype-table":{"type":"object","properties":{"leafType":{"enum":["table"]},"value":{"type":["number","string"]},"secondValue":{"type":["number","string"]}}},"has-leaftype-date":{"type":"object","properties":{"leafType":{"enum":["date"]},"value":{"type":"string"},"secondValue":{"type":"string"}}},"has-leaftype-text":{"type":"object","properties":{"leafType":{"enum":["text"]},"not":{"type":"object","required":["value","secondValue"]}}},"has-operation-between":{"type":"object","properties":{"operation":{"enum":["between"]}}},"has-operation-answered":{"type":"object","properties":{"operation":{"enum":["answered"]}}},"value-type-is-boolean-string":{"type":"object","properties":{"value":{"type":["string","boolean"]}}}},"type":"object","properties":{"condition":{"$ref":"#/definitions/condition"}},"required":["condition"],"additionalProperties":false};
const schema46 = {"type":"object","properties":{"nodeType":{"type":"string","enum":["and","or","not","leaf"]},"children":{"type":"array","items":{"$ref":"#/definitions/condition"}},"leafType":{"type":"string","enum":["question","slider","date","text","table"]},"questionLabel":{"type":"string"},"value":{"type":["number","string","boolean"]},"operation":{"anyOf":[{"type":"string","enum":["less","lessEqual","greater","greaterEqual","equals","notEquals","between","answered"]},{"type":"string","maxLength":0}]},"secondValue":{"type":["number","string"]}},"required":["nodeType"],"additionalProperties":false,"allOf":[{"$ref":"#/definitions/and-or-not-require-children"},{"$ref":"#/definitions/leaf-requires-leafattributes"}]};
const schema47 = {"oneOf":[{"$ref":"#/definitions/is-leaf"},{"allOf":[{"not":{"$ref":"#/definitions/is-leaf"}},{"$ref":"#/definitions/is-not"},{"type":"object","required":["children"]},{"not":{"type":"object","required":["leafType"]}},{"not":{"type":"object","required":["questionLabel"]}},{"not":{"type":"object","required":["value"]}},{"not":{"type":"object","required":["operation"]}},{"not":{"type":"object","required":["secondValue"]}},{"type":"object","properties":{"children":{"type":"array","maxItems":1}}}]},{"allOf":[{"not":{"$ref":"#/definitions/is-leaf"}},{"not":{"$ref":"#/definitions/is-not"}},{"type":"object","required":["children"]},{"not":{"type":"object","required":["leafType"]}},{"not":{"type":"object","required":["questionLabel"]}},{"not":{"type":"object","required":["value"]}},{"not":{"type":"object","required":["operation"]}},{"not":{"type":"object","required":["secondValue"]}}]}]};
const schema48 = {"type":"object","properties":{"nodeType":{"enum":["leaf"]}}};
const schema50 = {"type":"object","properties":{"nodeType":{"enum":["not"]}}};

function validate29(data, {instancePath="", parentData, parentDataProperty, rootData=data}={}){
let vErrors = null;
let errors = 0;
const _errs0 = errors;
let valid0 = false;
let passing0 = null;
const _errs1 = errors;
const _errs2 = errors;
if(errors === _errs2){
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.nodeType !== undefined){
if(!(data.nodeType === "leaf")){
const err0 = {instancePath:instancePath+"/nodeType",schemaPath:"#/definitions/is-leaf/properties/nodeType/enum",keyword:"enum",params:{allowedValues: schema48.properties.nodeType.enum},message:"must be equal to one of the allowed values"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
}
}
else {
const err1 = {instancePath,schemaPath:"#/definitions/is-leaf/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
}
var _valid0 = _errs1 === errors;
if(_valid0){
valid0 = true;
passing0 = 0;
}
const _errs5 = errors;
const _errs6 = errors;
const _errs7 = errors;
const _errs8 = errors;
const _errs9 = errors;
if(errors === _errs9){
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.nodeType !== undefined){
if(!(data.nodeType === "leaf")){
const err2 = {};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
}
}
else {
const err3 = {};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
}
var valid4 = _errs8 === errors;
if(valid4){
const err4 = {instancePath,schemaPath:"#/oneOf/1/allOf/0/not",keyword:"not",params:{},message:"must NOT be valid"};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
else {
errors = _errs7;
if(vErrors !== null){
if(_errs7){
vErrors.length = _errs7;
}
else {
vErrors = null;
}
}
}
var valid3 = _errs6 === errors;
if(valid3){
const _errs12 = errors;
const _errs13 = errors;
if(errors === _errs13){
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.nodeType !== undefined){
if(!(data.nodeType === "not")){
const err5 = {instancePath:instancePath+"/nodeType",schemaPath:"#/definitions/is-not/properties/nodeType/enum",keyword:"enum",params:{allowedValues: schema50.properties.nodeType.enum},message:"must be equal to one of the allowed values"};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
}
}
else {
const err6 = {instancePath,schemaPath:"#/definitions/is-not/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err6];
}
else {
vErrors.push(err6);
}
errors++;
}
}
var valid3 = _errs12 === errors;
if(valid3){
const _errs16 = errors;
if(errors === _errs16){
if(data && typeof data == "object" && !Array.isArray(data)){
let missing0;
if((data.children === undefined) && (missing0 = "children")){
const err7 = {instancePath,schemaPath:"#/oneOf/1/allOf/2/required",keyword:"required",params:{missingProperty: missing0},message:"must have required property '"+missing0+"'"};
if(vErrors === null){
vErrors = [err7];
}
else {
vErrors.push(err7);
}
errors++;
}
}
else {
const err8 = {instancePath,schemaPath:"#/oneOf/1/allOf/2/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err8];
}
else {
vErrors.push(err8);
}
errors++;
}
}
var valid3 = _errs16 === errors;
if(valid3){
const _errs18 = errors;
const _errs19 = errors;
const _errs20 = errors;
if(errors === _errs20){
if(data && typeof data == "object" && !Array.isArray(data)){
let missing1;
if((data.leafType === undefined) && (missing1 = "leafType")){
const err9 = {};
if(vErrors === null){
vErrors = [err9];
}
else {
vErrors.push(err9);
}
errors++;
}
}
else {
const err10 = {};
if(vErrors === null){
vErrors = [err10];
}
else {
vErrors.push(err10);
}
errors++;
}
}
var valid9 = _errs20 === errors;
if(valid9){
const err11 = {instancePath,schemaPath:"#/oneOf/1/allOf/3/not",keyword:"not",params:{},message:"must NOT be valid"};
if(vErrors === null){
vErrors = [err11];
}
else {
vErrors.push(err11);
}
errors++;
}
else {
errors = _errs19;
if(vErrors !== null){
if(_errs19){
vErrors.length = _errs19;
}
else {
vErrors = null;
}
}
}
var valid3 = _errs18 === errors;
if(valid3){
const _errs22 = errors;
const _errs23 = errors;
const _errs24 = errors;
if(errors === _errs24){
if(data && typeof data == "object" && !Array.isArray(data)){
let missing2;
if((data.questionLabel === undefined) && (missing2 = "questionLabel")){
const err12 = {};
if(vErrors === null){
vErrors = [err12];
}
else {
vErrors.push(err12);
}
errors++;
}
}
else {
const err13 = {};
if(vErrors === null){
vErrors = [err13];
}
else {
vErrors.push(err13);
}
errors++;
}
}
var valid10 = _errs24 === errors;
if(valid10){
const err14 = {instancePath,schemaPath:"#/oneOf/1/allOf/4/not",keyword:"not",params:{},message:"must NOT be valid"};
if(vErrors === null){
vErrors = [err14];
}
else {
vErrors.push(err14);
}
errors++;
}
else {
errors = _errs23;
if(vErrors !== null){
if(_errs23){
vErrors.length = _errs23;
}
else {
vErrors = null;
}
}
}
var valid3 = _errs22 === errors;
if(valid3){
const _errs26 = errors;
const _errs27 = errors;
const _errs28 = errors;
if(errors === _errs28){
if(data && typeof data == "object" && !Array.isArray(data)){
let missing3;
if((data.value === undefined) && (missing3 = "value")){
const err15 = {};
if(vErrors === null){
vErrors = [err15];
}
else {
vErrors.push(err15);
}
errors++;
}
}
else {
const err16 = {};
if(vErrors === null){
vErrors = [err16];
}
else {
vErrors.push(err16);
}
errors++;
}
}
var valid11 = _errs28 === errors;
if(valid11){
const err17 = {instancePath,schemaPath:"#/oneOf/1/allOf/5/not",keyword:"not",params:{},message:"must NOT be valid"};
if(vErrors === null){
vErrors = [err17];
}
else {
vErrors.push(err17);
}
errors++;
}
else {
errors = _errs27;
if(vErrors !== null){
if(_errs27){
vErrors.length = _errs27;
}
else {
vErrors = null;
}
}
}
var valid3 = _errs26 === errors;
if(valid3){
const _errs30 = errors;
const _errs31 = errors;
const _errs32 = errors;
if(errors === _errs32){
if(data && typeof data == "object" && !Array.isArray(data)){
let missing4;
if((data.operation === undefined) && (missing4 = "operation")){
const err18 = {};
if(vErrors === null){
vErrors = [err18];
}
else {
vErrors.push(err18);
}
errors++;
}
}
else {
const err19 = {};
if(vErrors === null){
vErrors = [err19];
}
else {
vErrors.push(err19);
}
errors++;
}
}
var valid12 = _errs32 === errors;
if(valid12){
const err20 = {instancePath,schemaPath:"#/oneOf/1/allOf/6/not",keyword:"not",params:{},message:"must NOT be valid"};
if(vErrors === null){
vErrors = [err20];
}
else {
vErrors.push(err20);
}
errors++;
}
else {
errors = _errs31;
if(vErrors !== null){
if(_errs31){
vErrors.length = _errs31;
}
else {
vErrors = null;
}
}
}
var valid3 = _errs30 === errors;
if(valid3){
const _errs34 = errors;
const _errs35 = errors;
const _errs36 = errors;
if(errors === _errs36){
if(data && typeof data == "object" && !Array.isArray(data)){
let missing5;
if((data.secondValue === undefined) && (missing5 = "secondValue")){
const err21 = {};
if(vErrors === null){
vErrors = [err21];
}
else {
vErrors.push(err21);
}
errors++;
}
}
else {
const err22 = {};
if(vErrors === null){
vErrors = [err22];
}
else {
vErrors.push(err22);
}
errors++;
}
}
var valid13 = _errs36 === errors;
if(valid13){
const err23 = {instancePath,schemaPath:"#/oneOf/1/allOf/7/not",keyword:"not",params:{},message:"must NOT be valid"};
if(vErrors === null){
vErrors = [err23];
}
else {
vErrors.push(err23);
}
errors++;
}
else {
errors = _errs35;
if(vErrors !== null){
if(_errs35){
vErrors.length = _errs35;
}
else {
vErrors = null;
}
}
}
var valid3 = _errs34 === errors;
if(valid3){
const _errs38 = errors;
if(errors === _errs38){
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.children !== undefined){
let data3 = data.children;
const _errs40 = errors;
if(errors === _errs40){
if(Array.isArray(data3)){
if(data3.length > 1){
const err24 = {instancePath:instancePath+"/children",schemaPath:"#/oneOf/1/allOf/8/properties/children/maxItems",keyword:"maxItems",params:{limit: 1},message:"must NOT have more than 1 items"};
if(vErrors === null){
vErrors = [err24];
}
else {
vErrors.push(err24);
}
errors++;
}
}
else {
const err25 = {instancePath:instancePath+"/children",schemaPath:"#/oneOf/1/allOf/8/properties/children/type",keyword:"type",params:{type: "array"},message:"must be array"};
if(vErrors === null){
vErrors = [err25];
}
else {
vErrors.push(err25);
}
errors++;
}
}
}
}
else {
const err26 = {instancePath,schemaPath:"#/oneOf/1/allOf/8/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err26];
}
else {
vErrors.push(err26);
}
errors++;
}
}
var valid3 = _errs38 === errors;
}
}
}
}
}
}
}
}
var _valid0 = _errs5 === errors;
if(_valid0 && valid0){
valid0 = false;
passing0 = [passing0, 1];
}
else {
if(_valid0){
valid0 = true;
passing0 = 1;
}
const _errs42 = errors;
const _errs43 = errors;
const _errs44 = errors;
const _errs45 = errors;
const _errs46 = errors;
if(errors === _errs46){
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.nodeType !== undefined){
if(!(data.nodeType === "leaf")){
const err27 = {};
if(vErrors === null){
vErrors = [err27];
}
else {
vErrors.push(err27);
}
errors++;
}
}
}
else {
const err28 = {};
if(vErrors === null){
vErrors = [err28];
}
else {
vErrors.push(err28);
}
errors++;
}
}
var valid16 = _errs45 === errors;
if(valid16){
const err29 = {instancePath,schemaPath:"#/oneOf/2/allOf/0/not",keyword:"not",params:{},message:"must NOT be valid"};
if(vErrors === null){
vErrors = [err29];
}
else {
vErrors.push(err29);
}
errors++;
}
else {
errors = _errs44;
if(vErrors !== null){
if(_errs44){
vErrors.length = _errs44;
}
else {
vErrors = null;
}
}
}
var valid15 = _errs43 === errors;
if(valid15){
const _errs49 = errors;
const _errs50 = errors;
const _errs51 = errors;
const _errs52 = errors;
if(errors === _errs52){
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.nodeType !== undefined){
if(!(data.nodeType === "not")){
const err30 = {};
if(vErrors === null){
vErrors = [err30];
}
else {
vErrors.push(err30);
}
errors++;
}
}
}
else {
const err31 = {};
if(vErrors === null){
vErrors = [err31];
}
else {
vErrors.push(err31);
}
errors++;
}
}
var valid19 = _errs51 === errors;
if(valid19){
const err32 = {instancePath,schemaPath:"#/oneOf/2/allOf/1/not",keyword:"not",params:{},message:"must NOT be valid"};
if(vErrors === null){
vErrors = [err32];
}
else {
vErrors.push(err32);
}
errors++;
}
else {
errors = _errs50;
if(vErrors !== null){
if(_errs50){
vErrors.length = _errs50;
}
else {
vErrors = null;
}
}
}
var valid15 = _errs49 === errors;
if(valid15){
const _errs55 = errors;
if(errors === _errs55){
if(data && typeof data == "object" && !Array.isArray(data)){
let missing6;
if((data.children === undefined) && (missing6 = "children")){
const err33 = {instancePath,schemaPath:"#/oneOf/2/allOf/2/required",keyword:"required",params:{missingProperty: missing6},message:"must have required property '"+missing6+"'"};
if(vErrors === null){
vErrors = [err33];
}
else {
vErrors.push(err33);
}
errors++;
}
}
else {
const err34 = {instancePath,schemaPath:"#/oneOf/2/allOf/2/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err34];
}
else {
vErrors.push(err34);
}
errors++;
}
}
var valid15 = _errs55 === errors;
if(valid15){
const _errs57 = errors;
const _errs58 = errors;
const _errs59 = errors;
if(errors === _errs59){
if(data && typeof data == "object" && !Array.isArray(data)){
let missing7;
if((data.leafType === undefined) && (missing7 = "leafType")){
const err35 = {};
if(vErrors === null){
vErrors = [err35];
}
else {
vErrors.push(err35);
}
errors++;
}
}
else {
const err36 = {};
if(vErrors === null){
vErrors = [err36];
}
else {
vErrors.push(err36);
}
errors++;
}
}
var valid22 = _errs59 === errors;
if(valid22){
const err37 = {instancePath,schemaPath:"#/oneOf/2/allOf/3/not",keyword:"not",params:{},message:"must NOT be valid"};
if(vErrors === null){
vErrors = [err37];
}
else {
vErrors.push(err37);
}
errors++;
}
else {
errors = _errs58;
if(vErrors !== null){
if(_errs58){
vErrors.length = _errs58;
}
else {
vErrors = null;
}
}
}
var valid15 = _errs57 === errors;
if(valid15){
const _errs61 = errors;
const _errs62 = errors;
const _errs63 = errors;
if(errors === _errs63){
if(data && typeof data == "object" && !Array.isArray(data)){
let missing8;
if((data.questionLabel === undefined) && (missing8 = "questionLabel")){
const err38 = {};
if(vErrors === null){
vErrors = [err38];
}
else {
vErrors.push(err38);
}
errors++;
}
}
else {
const err39 = {};
if(vErrors === null){
vErrors = [err39];
}
else {
vErrors.push(err39);
}
errors++;
}
}
var valid23 = _errs63 === errors;
if(valid23){
const err40 = {instancePath,schemaPath:"#/oneOf/2/allOf/4/not",keyword:"not",params:{},message:"must NOT be valid"};
if(vErrors === null){
vErrors = [err40];
}
else {
vErrors.push(err40);
}
errors++;
}
else {
errors = _errs62;
if(vErrors !== null){
if(_errs62){
vErrors.length = _errs62;
}
else {
vErrors = null;
}
}
}
var valid15 = _errs61 === errors;
if(valid15){
const _errs65 = errors;
const _errs66 = errors;
const _errs67 = errors;
if(errors === _errs67){
if(data && typeof data == "object" && !Array.isArray(data)){
let missing9;
if((data.value === undefined) && (missing9 = "value")){
const err41 = {};
if(vErrors === null){
vErrors = [err41];
}
else {
vErrors.push(err41);
}
errors++;
}
}
else {
const err42 = {};
if(vErrors === null){
vErrors = [err42];
}
else {
vErrors.push(err42);
}
errors++;
}
}
var valid24 = _errs67 === errors;
if(valid24){
const err43 = {instancePath,schemaPath:"#/oneOf/2/allOf/5/not",keyword:"not",params:{},message:"must NOT be valid"};
if(vErrors === null){
vErrors = [err43];
}
else {
vErrors.push(err43);
}
errors++;
}
else {
errors = _errs66;
if(vErrors !== null){
if(_errs66){
vErrors.length = _errs66;
}
else {
vErrors = null;
}
}
}
var valid15 = _errs65 === errors;
if(valid15){
const _errs69 = errors;
const _errs70 = errors;
const _errs71 = errors;
if(errors === _errs71){
if(data && typeof data == "object" && !Array.isArray(data)){
let missing10;
if((data.operation === undefined) && (missing10 = "operation")){
const err44 = {};
if(vErrors === null){
vErrors = [err44];
}
else {
vErrors.push(err44);
}
errors++;
}
}
else {
const err45 = {};
if(vErrors === null){
vErrors = [err45];
}
else {
vErrors.push(err45);
}
errors++;
}
}
var valid25 = _errs71 === errors;
if(valid25){
const err46 = {instancePath,schemaPath:"#/oneOf/2/allOf/6/not",keyword:"not",params:{},message:"must NOT be valid"};
if(vErrors === null){
vErrors = [err46];
}
else {
vErrors.push(err46);
}
errors++;
}
else {
errors = _errs70;
if(vErrors !== null){
if(_errs70){
vErrors.length = _errs70;
}
else {
vErrors = null;
}
}
}
var valid15 = _errs69 === errors;
if(valid15){
const _errs73 = errors;
const _errs74 = errors;
const _errs75 = errors;
if(errors === _errs75){
if(data && typeof data == "object" && !Array.isArray(data)){
let missing11;
if((data.secondValue === undefined) && (missing11 = "secondValue")){
const err47 = {};
if(vErrors === null){
vErrors = [err47];
}
else {
vErrors.push(err47);
}
errors++;
}
}
else {
const err48 = {};
if(vErrors === null){
vErrors = [err48];
}
else {
vErrors.push(err48);
}
errors++;
}
}
var valid26 = _errs75 === errors;
if(valid26){
const err49 = {instancePath,schemaPath:"#/oneOf/2/allOf/7/not",keyword:"not",params:{},message:"must NOT be valid"};
if(vErrors === null){
vErrors = [err49];
}
else {
vErrors.push(err49);
}
errors++;
}
else {
errors = _errs74;
if(vErrors !== null){
if(_errs74){
vErrors.length = _errs74;
}
else {
vErrors = null;
}
}
}
var valid15 = _errs73 === errors;
}
}
}
}
}
}
}
var _valid0 = _errs42 === errors;
if(_valid0 && valid0){
valid0 = false;
passing0 = [passing0, 2];
}
else {
if(_valid0){
valid0 = true;
passing0 = 2;
}
}
}
if(!valid0){
const err50 = {instancePath,schemaPath:"#/oneOf",keyword:"oneOf",params:{passingSchemas: passing0},message:"must match exactly one schema in oneOf"};
if(vErrors === null){
vErrors = [err50];
}
else {
vErrors.push(err50);
}
errors++;
validate29.errors = vErrors;
return false;
}
else {
errors = _errs0;
if(vErrors !== null){
if(_errs0){
vErrors.length = _errs0;
}
else {
vErrors = null;
}
}
}
validate29.errors = vErrors;
return errors === 0;
}

const schema53 = {"oneOf":[{"not":{"$ref":"#/definitions/is-leaf"}},{"allOf":[{"$ref":"#/definitions/is-question-leaf"},{"type":"object","required":["leafType","questionLabel"]},{"oneOf":[{"allOf":[{"not":{"type":"object","required":["operation"]}},{"type":"object","required":["value"]}]},{"allOf":[{"$ref":"#/definitions/has-operation-answered"},{"not":{"type":"object","required":["value"]}}]}]},{"not":{"type":"object","required":["secondValue"]}},{"not":{"type":"object","required":["children"]}},{"$ref":"#/definitions/value-type-is-boolean-string"}]},{"allOf":[{"$ref":"#/definitions/is-leaf"},{"not":{"$ref":"#/definitions/is-question-leaf"}},{"type":"object","required":["leafType","questionLabel"]},{"oneOf":[{"allOf":[{"not":{"$ref":"#/definitions/has-operation-answered"}},{"type":"object","required":["value"]}]},{"allOf":[{"$ref":"#/definitions/has-operation-answered"},{"not":{"type":"object","required":["value"]}}]}]},{"not":{"type":"object","required":["children"]}},{"oneOf":[{"$ref":"#/definitions/has-leaftype-slider"},{"$ref":"#/definitions/has-leaftype-table"},{"$ref":"#/definitions/has-leaftype-text"},{"$ref":"#/definitions/has-leaftype-date"}]},{"oneOf":[{"allOf":[{"not":{"$ref":"#/definitions/has-operation-between"}},{"not":{"type":"object","required":["secondValue"]}}]},{"allOf":[{"$ref":"#/definitions/has-operation-between"},{"type":"object","required":["secondValue"]}]}]}]}]};
const schema55 = {"type":"object","properties":{"nodeType":{"enum":["leaf"]},"leafType":{"enum":["question"]}}};
const schema56 = {"type":"object","properties":{"operation":{"enum":["answered"]}}};
const schema57 = {"type":"object","properties":{"value":{"type":["string","boolean"]}}};
const schema62 = {"type":"object","properties":{"leafType":{"enum":["slider"]},"value":{"type":["number","string"]},"secondValue":{"type":["number","string"]}}};
const schema63 = {"type":"object","properties":{"leafType":{"enum":["table"]},"value":{"type":["number","string"]},"secondValue":{"type":["number","string"]}}};
const schema64 = {"type":"object","properties":{"leafType":{"enum":["text"]},"not":{"type":"object","required":["value","secondValue"]}}};
const schema65 = {"type":"object","properties":{"leafType":{"enum":["date"]},"value":{"type":"string"},"secondValue":{"type":"string"}}};
const schema66 = {"type":"object","properties":{"operation":{"enum":["between"]}}};

function validate31(data, {instancePath="", parentData, parentDataProperty, rootData=data}={}){
let vErrors = null;
let errors = 0;
const _errs0 = errors;
let valid0 = false;
let passing0 = null;
const _errs1 = errors;
const _errs2 = errors;
const _errs3 = errors;
const _errs4 = errors;
if(errors === _errs4){
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.nodeType !== undefined){
if(!(data.nodeType === "leaf")){
const err0 = {};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
}
}
else {
const err1 = {};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
}
var valid1 = _errs3 === errors;
if(valid1){
const err2 = {instancePath,schemaPath:"#/oneOf/0/not",keyword:"not",params:{},message:"must NOT be valid"};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
else {
errors = _errs2;
if(vErrors !== null){
if(_errs2){
vErrors.length = _errs2;
}
else {
vErrors = null;
}
}
}
var _valid0 = _errs1 === errors;
if(_valid0){
valid0 = true;
passing0 = 0;
}
const _errs7 = errors;
const _errs8 = errors;
const _errs9 = errors;
if(errors === _errs9){
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.nodeType !== undefined){
const _errs11 = errors;
if(!(data.nodeType === "leaf")){
const err3 = {instancePath:instancePath+"/nodeType",schemaPath:"#/definitions/is-question-leaf/properties/nodeType/enum",keyword:"enum",params:{allowedValues: schema55.properties.nodeType.enum},message:"must be equal to one of the allowed values"};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
var valid6 = _errs11 === errors;
}
else {
var valid6 = true;
}
if(valid6){
if(data.leafType !== undefined){
const _errs12 = errors;
if(!(data.leafType === "question")){
const err4 = {instancePath:instancePath+"/leafType",schemaPath:"#/definitions/is-question-leaf/properties/leafType/enum",keyword:"enum",params:{allowedValues: schema55.properties.leafType.enum},message:"must be equal to one of the allowed values"};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
var valid6 = _errs12 === errors;
}
else {
var valid6 = true;
}
}
}
else {
const err5 = {instancePath,schemaPath:"#/definitions/is-question-leaf/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
}
var valid4 = _errs8 === errors;
if(valid4){
const _errs13 = errors;
if(errors === _errs13){
if(data && typeof data == "object" && !Array.isArray(data)){
let missing0;
if(((data.leafType === undefined) && (missing0 = "leafType")) || ((data.questionLabel === undefined) && (missing0 = "questionLabel"))){
const err6 = {instancePath,schemaPath:"#/oneOf/1/allOf/1/required",keyword:"required",params:{missingProperty: missing0},message:"must have required property '"+missing0+"'"};
if(vErrors === null){
vErrors = [err6];
}
else {
vErrors.push(err6);
}
errors++;
}
}
else {
const err7 = {instancePath,schemaPath:"#/oneOf/1/allOf/1/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err7];
}
else {
vErrors.push(err7);
}
errors++;
}
}
var valid4 = _errs13 === errors;
if(valid4){
const _errs15 = errors;
const _errs16 = errors;
let valid7 = false;
let passing1 = null;
const _errs17 = errors;
const _errs18 = errors;
const _errs19 = errors;
const _errs20 = errors;
if(errors === _errs20){
if(data && typeof data == "object" && !Array.isArray(data)){
let missing1;
if((data.operation === undefined) && (missing1 = "operation")){
const err8 = {};
if(vErrors === null){
vErrors = [err8];
}
else {
vErrors.push(err8);
}
errors++;
}
}
else {
const err9 = {};
if(vErrors === null){
vErrors = [err9];
}
else {
vErrors.push(err9);
}
errors++;
}
}
var valid9 = _errs20 === errors;
if(valid9){
const err10 = {instancePath,schemaPath:"#/oneOf/1/allOf/2/oneOf/0/allOf/0/not",keyword:"not",params:{},message:"must NOT be valid"};
if(vErrors === null){
vErrors = [err10];
}
else {
vErrors.push(err10);
}
errors++;
}
else {
errors = _errs19;
if(vErrors !== null){
if(_errs19){
vErrors.length = _errs19;
}
else {
vErrors = null;
}
}
}
var valid8 = _errs18 === errors;
if(valid8){
const _errs22 = errors;
if(errors === _errs22){
if(data && typeof data == "object" && !Array.isArray(data)){
let missing2;
if((data.value === undefined) && (missing2 = "value")){
const err11 = {instancePath,schemaPath:"#/oneOf/1/allOf/2/oneOf/0/allOf/1/required",keyword:"required",params:{missingProperty: missing2},message:"must have required property '"+missing2+"'"};
if(vErrors === null){
vErrors = [err11];
}
else {
vErrors.push(err11);
}
errors++;
}
}
else {
const err12 = {instancePath,schemaPath:"#/oneOf/1/allOf/2/oneOf/0/allOf/1/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err12];
}
else {
vErrors.push(err12);
}
errors++;
}
}
var valid8 = _errs22 === errors;
}
var _valid1 = _errs17 === errors;
if(_valid1){
valid7 = true;
passing1 = 0;
}
const _errs24 = errors;
const _errs25 = errors;
const _errs26 = errors;
if(errors === _errs26){
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.operation !== undefined){
if(!(data.operation === "answered")){
const err13 = {instancePath:instancePath+"/operation",schemaPath:"#/definitions/has-operation-answered/properties/operation/enum",keyword:"enum",params:{allowedValues: schema56.properties.operation.enum},message:"must be equal to one of the allowed values"};
if(vErrors === null){
vErrors = [err13];
}
else {
vErrors.push(err13);
}
errors++;
}
}
}
else {
const err14 = {instancePath,schemaPath:"#/definitions/has-operation-answered/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err14];
}
else {
vErrors.push(err14);
}
errors++;
}
}
var valid10 = _errs25 === errors;
if(valid10){
const _errs29 = errors;
const _errs30 = errors;
const _errs31 = errors;
if(errors === _errs31){
if(data && typeof data == "object" && !Array.isArray(data)){
let missing3;
if((data.value === undefined) && (missing3 = "value")){
const err15 = {};
if(vErrors === null){
vErrors = [err15];
}
else {
vErrors.push(err15);
}
errors++;
}
}
else {
const err16 = {};
if(vErrors === null){
vErrors = [err16];
}
else {
vErrors.push(err16);
}
errors++;
}
}
var valid13 = _errs31 === errors;
if(valid13){
const err17 = {instancePath,schemaPath:"#/oneOf/1/allOf/2/oneOf/1/allOf/1/not",keyword:"not",params:{},message:"must NOT be valid"};
if(vErrors === null){
vErrors = [err17];
}
else {
vErrors.push(err17);
}
errors++;
}
else {
errors = _errs30;
if(vErrors !== null){
if(_errs30){
vErrors.length = _errs30;
}
else {
vErrors = null;
}
}
}
var valid10 = _errs29 === errors;
}
var _valid1 = _errs24 === errors;
if(_valid1 && valid7){
valid7 = false;
passing1 = [passing1, 1];
}
else {
if(_valid1){
valid7 = true;
passing1 = 1;
}
}
if(!valid7){
const err18 = {instancePath,schemaPath:"#/oneOf/1/allOf/2/oneOf",keyword:"oneOf",params:{passingSchemas: passing1},message:"must match exactly one schema in oneOf"};
if(vErrors === null){
vErrors = [err18];
}
else {
vErrors.push(err18);
}
errors++;
}
else {
errors = _errs16;
if(vErrors !== null){
if(_errs16){
vErrors.length = _errs16;
}
else {
vErrors = null;
}
}
}
var valid4 = _errs15 === errors;
if(valid4){
const _errs33 = errors;
const _errs34 = errors;
const _errs35 = errors;
if(errors === _errs35){
if(data && typeof data == "object" && !Array.isArray(data)){
let missing4;
if((data.secondValue === undefined) && (missing4 = "secondValue")){
const err19 = {};
if(vErrors === null){
vErrors = [err19];
}
else {
vErrors.push(err19);
}
errors++;
}
}
else {
const err20 = {};
if(vErrors === null){
vErrors = [err20];
}
else {
vErrors.push(err20);
}
errors++;
}
}
var valid14 = _errs35 === errors;
if(valid14){
const err21 = {instancePath,schemaPath:"#/oneOf/1/allOf/3/not",keyword:"not",params:{},message:"must NOT be valid"};
if(vErrors === null){
vErrors = [err21];
}
else {
vErrors.push(err21);
}
errors++;
}
else {
errors = _errs34;
if(vErrors !== null){
if(_errs34){
vErrors.length = _errs34;
}
else {
vErrors = null;
}
}
}
var valid4 = _errs33 === errors;
if(valid4){
const _errs37 = errors;
const _errs38 = errors;
const _errs39 = errors;
if(errors === _errs39){
if(data && typeof data == "object" && !Array.isArray(data)){
let missing5;
if((data.children === undefined) && (missing5 = "children")){
const err22 = {};
if(vErrors === null){
vErrors = [err22];
}
else {
vErrors.push(err22);
}
errors++;
}
}
else {
const err23 = {};
if(vErrors === null){
vErrors = [err23];
}
else {
vErrors.push(err23);
}
errors++;
}
}
var valid15 = _errs39 === errors;
if(valid15){
const err24 = {instancePath,schemaPath:"#/oneOf/1/allOf/4/not",keyword:"not",params:{},message:"must NOT be valid"};
if(vErrors === null){
vErrors = [err24];
}
else {
vErrors.push(err24);
}
errors++;
}
else {
errors = _errs38;
if(vErrors !== null){
if(_errs38){
vErrors.length = _errs38;
}
else {
vErrors = null;
}
}
}
var valid4 = _errs37 === errors;
if(valid4){
const _errs41 = errors;
const _errs42 = errors;
if(errors === _errs42){
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.value !== undefined){
let data4 = data.value;
if((typeof data4 !== "string") && (typeof data4 !== "boolean")){
const err25 = {instancePath:instancePath+"/value",schemaPath:"#/definitions/value-type-is-boolean-string/properties/value/type",keyword:"type",params:{type: schema57.properties.value.type},message:"must be string,boolean"};
if(vErrors === null){
vErrors = [err25];
}
else {
vErrors.push(err25);
}
errors++;
}
}
}
else {
const err26 = {instancePath,schemaPath:"#/definitions/value-type-is-boolean-string/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err26];
}
else {
vErrors.push(err26);
}
errors++;
}
}
var valid4 = _errs41 === errors;
}
}
}
}
}
var _valid0 = _errs7 === errors;
if(_valid0 && valid0){
valid0 = false;
passing0 = [passing0, 1];
}
else {
if(_valid0){
valid0 = true;
passing0 = 1;
}
const _errs46 = errors;
const _errs47 = errors;
const _errs48 = errors;
if(errors === _errs48){
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.nodeType !== undefined){
if(!(data.nodeType === "leaf")){
const err27 = {instancePath:instancePath+"/nodeType",schemaPath:"#/definitions/is-leaf/properties/nodeType/enum",keyword:"enum",params:{allowedValues: schema48.properties.nodeType.enum},message:"must be equal to one of the allowed values"};
if(vErrors === null){
vErrors = [err27];
}
else {
vErrors.push(err27);
}
errors++;
}
}
}
else {
const err28 = {instancePath,schemaPath:"#/definitions/is-leaf/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err28];
}
else {
vErrors.push(err28);
}
errors++;
}
}
var valid18 = _errs47 === errors;
if(valid18){
const _errs51 = errors;
const _errs52 = errors;
const _errs53 = errors;
const _errs54 = errors;
if(errors === _errs54){
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.nodeType !== undefined){
const _errs56 = errors;
if(!(data.nodeType === "leaf")){
const err29 = {};
if(vErrors === null){
vErrors = [err29];
}
else {
vErrors.push(err29);
}
errors++;
}
var valid23 = _errs56 === errors;
}
else {
var valid23 = true;
}
if(valid23){
if(data.leafType !== undefined){
const _errs57 = errors;
if(!(data.leafType === "question")){
const err30 = {};
if(vErrors === null){
vErrors = [err30];
}
else {
vErrors.push(err30);
}
errors++;
}
var valid23 = _errs57 === errors;
}
else {
var valid23 = true;
}
}
}
else {
const err31 = {};
if(vErrors === null){
vErrors = [err31];
}
else {
vErrors.push(err31);
}
errors++;
}
}
var valid21 = _errs53 === errors;
if(valid21){
const err32 = {instancePath,schemaPath:"#/oneOf/2/allOf/1/not",keyword:"not",params:{},message:"must NOT be valid"};
if(vErrors === null){
vErrors = [err32];
}
else {
vErrors.push(err32);
}
errors++;
}
else {
errors = _errs52;
if(vErrors !== null){
if(_errs52){
vErrors.length = _errs52;
}
else {
vErrors = null;
}
}
}
var valid18 = _errs51 === errors;
if(valid18){
const _errs58 = errors;
if(errors === _errs58){
if(data && typeof data == "object" && !Array.isArray(data)){
let missing6;
if(((data.leafType === undefined) && (missing6 = "leafType")) || ((data.questionLabel === undefined) && (missing6 = "questionLabel"))){
const err33 = {instancePath,schemaPath:"#/oneOf/2/allOf/2/required",keyword:"required",params:{missingProperty: missing6},message:"must have required property '"+missing6+"'"};
if(vErrors === null){
vErrors = [err33];
}
else {
vErrors.push(err33);
}
errors++;
}
}
else {
const err34 = {instancePath,schemaPath:"#/oneOf/2/allOf/2/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err34];
}
else {
vErrors.push(err34);
}
errors++;
}
}
var valid18 = _errs58 === errors;
if(valid18){
const _errs60 = errors;
const _errs61 = errors;
let valid24 = false;
let passing2 = null;
const _errs62 = errors;
const _errs63 = errors;
const _errs64 = errors;
const _errs65 = errors;
const _errs66 = errors;
if(errors === _errs66){
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.operation !== undefined){
if(!(data.operation === "answered")){
const err35 = {};
if(vErrors === null){
vErrors = [err35];
}
else {
vErrors.push(err35);
}
errors++;
}
}
}
else {
const err36 = {};
if(vErrors === null){
vErrors = [err36];
}
else {
vErrors.push(err36);
}
errors++;
}
}
var valid26 = _errs65 === errors;
if(valid26){
const err37 = {instancePath,schemaPath:"#/oneOf/2/allOf/3/oneOf/0/allOf/0/not",keyword:"not",params:{},message:"must NOT be valid"};
if(vErrors === null){
vErrors = [err37];
}
else {
vErrors.push(err37);
}
errors++;
}
else {
errors = _errs64;
if(vErrors !== null){
if(_errs64){
vErrors.length = _errs64;
}
else {
vErrors = null;
}
}
}
var valid25 = _errs63 === errors;
if(valid25){
const _errs69 = errors;
if(errors === _errs69){
if(data && typeof data == "object" && !Array.isArray(data)){
let missing7;
if((data.value === undefined) && (missing7 = "value")){
const err38 = {instancePath,schemaPath:"#/oneOf/2/allOf/3/oneOf/0/allOf/1/required",keyword:"required",params:{missingProperty: missing7},message:"must have required property '"+missing7+"'"};
if(vErrors === null){
vErrors = [err38];
}
else {
vErrors.push(err38);
}
errors++;
}
}
else {
const err39 = {instancePath,schemaPath:"#/oneOf/2/allOf/3/oneOf/0/allOf/1/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err39];
}
else {
vErrors.push(err39);
}
errors++;
}
}
var valid25 = _errs69 === errors;
}
var _valid2 = _errs62 === errors;
if(_valid2){
valid24 = true;
passing2 = 0;
}
const _errs71 = errors;
const _errs72 = errors;
const _errs73 = errors;
if(errors === _errs73){
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.operation !== undefined){
if(!(data.operation === "answered")){
const err40 = {instancePath:instancePath+"/operation",schemaPath:"#/definitions/has-operation-answered/properties/operation/enum",keyword:"enum",params:{allowedValues: schema56.properties.operation.enum},message:"must be equal to one of the allowed values"};
if(vErrors === null){
vErrors = [err40];
}
else {
vErrors.push(err40);
}
errors++;
}
}
}
else {
const err41 = {instancePath,schemaPath:"#/definitions/has-operation-answered/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err41];
}
else {
vErrors.push(err41);
}
errors++;
}
}
var valid29 = _errs72 === errors;
if(valid29){
const _errs76 = errors;
const _errs77 = errors;
const _errs78 = errors;
if(errors === _errs78){
if(data && typeof data == "object" && !Array.isArray(data)){
let missing8;
if((data.value === undefined) && (missing8 = "value")){
const err42 = {};
if(vErrors === null){
vErrors = [err42];
}
else {
vErrors.push(err42);
}
errors++;
}
}
else {
const err43 = {};
if(vErrors === null){
vErrors = [err43];
}
else {
vErrors.push(err43);
}
errors++;
}
}
var valid32 = _errs78 === errors;
if(valid32){
const err44 = {instancePath,schemaPath:"#/oneOf/2/allOf/3/oneOf/1/allOf/1/not",keyword:"not",params:{},message:"must NOT be valid"};
if(vErrors === null){
vErrors = [err44];
}
else {
vErrors.push(err44);
}
errors++;
}
else {
errors = _errs77;
if(vErrors !== null){
if(_errs77){
vErrors.length = _errs77;
}
else {
vErrors = null;
}
}
}
var valid29 = _errs76 === errors;
}
var _valid2 = _errs71 === errors;
if(_valid2 && valid24){
valid24 = false;
passing2 = [passing2, 1];
}
else {
if(_valid2){
valid24 = true;
passing2 = 1;
}
}
if(!valid24){
const err45 = {instancePath,schemaPath:"#/oneOf/2/allOf/3/oneOf",keyword:"oneOf",params:{passingSchemas: passing2},message:"must match exactly one schema in oneOf"};
if(vErrors === null){
vErrors = [err45];
}
else {
vErrors.push(err45);
}
errors++;
}
else {
errors = _errs61;
if(vErrors !== null){
if(_errs61){
vErrors.length = _errs61;
}
else {
vErrors = null;
}
}
}
var valid18 = _errs60 === errors;
if(valid18){
const _errs80 = errors;
const _errs81 = errors;
const _errs82 = errors;
if(errors === _errs82){
if(data && typeof data == "object" && !Array.isArray(data)){
let missing9;
if((data.children === undefined) && (missing9 = "children")){
const err46 = {};
if(vErrors === null){
vErrors = [err46];
}
else {
vErrors.push(err46);
}
errors++;
}
}
else {
const err47 = {};
if(vErrors === null){
vErrors = [err47];
}
else {
vErrors.push(err47);
}
errors++;
}
}
var valid33 = _errs82 === errors;
if(valid33){
const err48 = {instancePath,schemaPath:"#/oneOf/2/allOf/4/not",keyword:"not",params:{},message:"must NOT be valid"};
if(vErrors === null){
vErrors = [err48];
}
else {
vErrors.push(err48);
}
errors++;
}
else {
errors = _errs81;
if(vErrors !== null){
if(_errs81){
vErrors.length = _errs81;
}
else {
vErrors = null;
}
}
}
var valid18 = _errs80 === errors;
if(valid18){
const _errs84 = errors;
const _errs85 = errors;
let valid34 = false;
let passing3 = null;
const _errs86 = errors;
const _errs87 = errors;
if(errors === _errs87){
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.leafType !== undefined){
const _errs89 = errors;
if(!(data.leafType === "slider")){
const err49 = {instancePath:instancePath+"/leafType",schemaPath:"#/definitions/has-leaftype-slider/properties/leafType/enum",keyword:"enum",params:{allowedValues: schema62.properties.leafType.enum},message:"must be equal to one of the allowed values"};
if(vErrors === null){
vErrors = [err49];
}
else {
vErrors.push(err49);
}
errors++;
}
var valid36 = _errs89 === errors;
}
else {
var valid36 = true;
}
if(valid36){
if(data.value !== undefined){
let data11 = data.value;
const _errs90 = errors;
if((!((typeof data11 == "number") && (isFinite(data11)))) && (typeof data11 !== "string")){
const err50 = {instancePath:instancePath+"/value",schemaPath:"#/definitions/has-leaftype-slider/properties/value/type",keyword:"type",params:{type: schema62.properties.value.type},message:"must be number,string"};
if(vErrors === null){
vErrors = [err50];
}
else {
vErrors.push(err50);
}
errors++;
}
var valid36 = _errs90 === errors;
}
else {
var valid36 = true;
}
if(valid36){
if(data.secondValue !== undefined){
let data12 = data.secondValue;
const _errs92 = errors;
if((!((typeof data12 == "number") && (isFinite(data12)))) && (typeof data12 !== "string")){
const err51 = {instancePath:instancePath+"/secondValue",schemaPath:"#/definitions/has-leaftype-slider/properties/secondValue/type",keyword:"type",params:{type: schema62.properties.secondValue.type},message:"must be number,string"};
if(vErrors === null){
vErrors = [err51];
}
else {
vErrors.push(err51);
}
errors++;
}
var valid36 = _errs92 === errors;
}
else {
var valid36 = true;
}
}
}
}
else {
const err52 = {instancePath,schemaPath:"#/definitions/has-leaftype-slider/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err52];
}
else {
vErrors.push(err52);
}
errors++;
}
}
var _valid3 = _errs86 === errors;
if(_valid3){
valid34 = true;
passing3 = 0;
}
const _errs94 = errors;
const _errs95 = errors;
if(errors === _errs95){
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.leafType !== undefined){
const _errs97 = errors;
if(!(data.leafType === "table")){
const err53 = {instancePath:instancePath+"/leafType",schemaPath:"#/definitions/has-leaftype-table/properties/leafType/enum",keyword:"enum",params:{allowedValues: schema63.properties.leafType.enum},message:"must be equal to one of the allowed values"};
if(vErrors === null){
vErrors = [err53];
}
else {
vErrors.push(err53);
}
errors++;
}
var valid38 = _errs97 === errors;
}
else {
var valid38 = true;
}
if(valid38){
if(data.value !== undefined){
let data14 = data.value;
const _errs98 = errors;
if((!((typeof data14 == "number") && (isFinite(data14)))) && (typeof data14 !== "string")){
const err54 = {instancePath:instancePath+"/value",schemaPath:"#/definitions/has-leaftype-table/properties/value/type",keyword:"type",params:{type: schema63.properties.value.type},message:"must be number,string"};
if(vErrors === null){
vErrors = [err54];
}
else {
vErrors.push(err54);
}
errors++;
}
var valid38 = _errs98 === errors;
}
else {
var valid38 = true;
}
if(valid38){
if(data.secondValue !== undefined){
let data15 = data.secondValue;
const _errs100 = errors;
if((!((typeof data15 == "number") && (isFinite(data15)))) && (typeof data15 !== "string")){
const err55 = {instancePath:instancePath+"/secondValue",schemaPath:"#/definitions/has-leaftype-table/properties/secondValue/type",keyword:"type",params:{type: schema63.properties.secondValue.type},message:"must be number,string"};
if(vErrors === null){
vErrors = [err55];
}
else {
vErrors.push(err55);
}
errors++;
}
var valid38 = _errs100 === errors;
}
else {
var valid38 = true;
}
}
}
}
else {
const err56 = {instancePath,schemaPath:"#/definitions/has-leaftype-table/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err56];
}
else {
vErrors.push(err56);
}
errors++;
}
}
var _valid3 = _errs94 === errors;
if(_valid3 && valid34){
valid34 = false;
passing3 = [passing3, 1];
}
else {
if(_valid3){
valid34 = true;
passing3 = 1;
}
const _errs102 = errors;
const _errs103 = errors;
if(errors === _errs103){
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.leafType !== undefined){
const _errs105 = errors;
if(!(data.leafType === "text")){
const err57 = {instancePath:instancePath+"/leafType",schemaPath:"#/definitions/has-leaftype-text/properties/leafType/enum",keyword:"enum",params:{allowedValues: schema64.properties.leafType.enum},message:"must be equal to one of the allowed values"};
if(vErrors === null){
vErrors = [err57];
}
else {
vErrors.push(err57);
}
errors++;
}
var valid40 = _errs105 === errors;
}
else {
var valid40 = true;
}
if(valid40){
if(data.not !== undefined){
let data17 = data.not;
const _errs106 = errors;
if(errors === _errs106){
if(data17 && typeof data17 == "object" && !Array.isArray(data17)){
let missing10;
if(((data17.value === undefined) && (missing10 = "value")) || ((data17.secondValue === undefined) && (missing10 = "secondValue"))){
const err58 = {instancePath:instancePath+"/not",schemaPath:"#/definitions/has-leaftype-text/properties/not/required",keyword:"required",params:{missingProperty: missing10},message:"must have required property '"+missing10+"'"};
if(vErrors === null){
vErrors = [err58];
}
else {
vErrors.push(err58);
}
errors++;
}
}
else {
const err59 = {instancePath:instancePath+"/not",schemaPath:"#/definitions/has-leaftype-text/properties/not/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err59];
}
else {
vErrors.push(err59);
}
errors++;
}
}
var valid40 = _errs106 === errors;
}
else {
var valid40 = true;
}
}
}
else {
const err60 = {instancePath,schemaPath:"#/definitions/has-leaftype-text/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err60];
}
else {
vErrors.push(err60);
}
errors++;
}
}
var _valid3 = _errs102 === errors;
if(_valid3 && valid34){
valid34 = false;
passing3 = [passing3, 2];
}
else {
if(_valid3){
valid34 = true;
passing3 = 2;
}
const _errs108 = errors;
const _errs109 = errors;
if(errors === _errs109){
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.leafType !== undefined){
const _errs111 = errors;
if(!(data.leafType === "date")){
const err61 = {instancePath:instancePath+"/leafType",schemaPath:"#/definitions/has-leaftype-date/properties/leafType/enum",keyword:"enum",params:{allowedValues: schema65.properties.leafType.enum},message:"must be equal to one of the allowed values"};
if(vErrors === null){
vErrors = [err61];
}
else {
vErrors.push(err61);
}
errors++;
}
var valid42 = _errs111 === errors;
}
else {
var valid42 = true;
}
if(valid42){
if(data.value !== undefined){
const _errs112 = errors;
if(typeof data.value !== "string"){
const err62 = {instancePath:instancePath+"/value",schemaPath:"#/definitions/has-leaftype-date/properties/value/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err62];
}
else {
vErrors.push(err62);
}
errors++;
}
var valid42 = _errs112 === errors;
}
else {
var valid42 = true;
}
if(valid42){
if(data.secondValue !== undefined){
const _errs114 = errors;
if(typeof data.secondValue !== "string"){
const err63 = {instancePath:instancePath+"/secondValue",schemaPath:"#/definitions/has-leaftype-date/properties/secondValue/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err63];
}
else {
vErrors.push(err63);
}
errors++;
}
var valid42 = _errs114 === errors;
}
else {
var valid42 = true;
}
}
}
}
else {
const err64 = {instancePath,schemaPath:"#/definitions/has-leaftype-date/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err64];
}
else {
vErrors.push(err64);
}
errors++;
}
}
var _valid3 = _errs108 === errors;
if(_valid3 && valid34){
valid34 = false;
passing3 = [passing3, 3];
}
else {
if(_valid3){
valid34 = true;
passing3 = 3;
}
}
}
}
if(!valid34){
const err65 = {instancePath,schemaPath:"#/oneOf/2/allOf/5/oneOf",keyword:"oneOf",params:{passingSchemas: passing3},message:"must match exactly one schema in oneOf"};
if(vErrors === null){
vErrors = [err65];
}
else {
vErrors.push(err65);
}
errors++;
}
else {
errors = _errs85;
if(vErrors !== null){
if(_errs85){
vErrors.length = _errs85;
}
else {
vErrors = null;
}
}
}
var valid18 = _errs84 === errors;
if(valid18){
const _errs116 = errors;
const _errs117 = errors;
let valid43 = false;
let passing4 = null;
const _errs118 = errors;
const _errs119 = errors;
const _errs120 = errors;
const _errs121 = errors;
const _errs122 = errors;
if(errors === _errs122){
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.operation !== undefined){
if(!(data.operation === "between")){
const err66 = {};
if(vErrors === null){
vErrors = [err66];
}
else {
vErrors.push(err66);
}
errors++;
}
}
}
else {
const err67 = {};
if(vErrors === null){
vErrors = [err67];
}
else {
vErrors.push(err67);
}
errors++;
}
}
var valid45 = _errs121 === errors;
if(valid45){
const err68 = {instancePath,schemaPath:"#/oneOf/2/allOf/6/oneOf/0/allOf/0/not",keyword:"not",params:{},message:"must NOT be valid"};
if(vErrors === null){
vErrors = [err68];
}
else {
vErrors.push(err68);
}
errors++;
}
else {
errors = _errs120;
if(vErrors !== null){
if(_errs120){
vErrors.length = _errs120;
}
else {
vErrors = null;
}
}
}
var valid44 = _errs119 === errors;
if(valid44){
const _errs125 = errors;
const _errs126 = errors;
const _errs127 = errors;
if(errors === _errs127){
if(data && typeof data == "object" && !Array.isArray(data)){
let missing11;
if((data.secondValue === undefined) && (missing11 = "secondValue")){
const err69 = {};
if(vErrors === null){
vErrors = [err69];
}
else {
vErrors.push(err69);
}
errors++;
}
}
else {
const err70 = {};
if(vErrors === null){
vErrors = [err70];
}
else {
vErrors.push(err70);
}
errors++;
}
}
var valid48 = _errs127 === errors;
if(valid48){
const err71 = {instancePath,schemaPath:"#/oneOf/2/allOf/6/oneOf/0/allOf/1/not",keyword:"not",params:{},message:"must NOT be valid"};
if(vErrors === null){
vErrors = [err71];
}
else {
vErrors.push(err71);
}
errors++;
}
else {
errors = _errs126;
if(vErrors !== null){
if(_errs126){
vErrors.length = _errs126;
}
else {
vErrors = null;
}
}
}
var valid44 = _errs125 === errors;
}
var _valid4 = _errs118 === errors;
if(_valid4){
valid43 = true;
passing4 = 0;
}
const _errs129 = errors;
const _errs130 = errors;
const _errs131 = errors;
if(errors === _errs131){
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.operation !== undefined){
if(!(data.operation === "between")){
const err72 = {instancePath:instancePath+"/operation",schemaPath:"#/definitions/has-operation-between/properties/operation/enum",keyword:"enum",params:{allowedValues: schema66.properties.operation.enum},message:"must be equal to one of the allowed values"};
if(vErrors === null){
vErrors = [err72];
}
else {
vErrors.push(err72);
}
errors++;
}
}
}
else {
const err73 = {instancePath,schemaPath:"#/definitions/has-operation-between/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err73];
}
else {
vErrors.push(err73);
}
errors++;
}
}
var valid49 = _errs130 === errors;
if(valid49){
const _errs134 = errors;
if(errors === _errs134){
if(data && typeof data == "object" && !Array.isArray(data)){
let missing12;
if((data.secondValue === undefined) && (missing12 = "secondValue")){
const err74 = {instancePath,schemaPath:"#/oneOf/2/allOf/6/oneOf/1/allOf/1/required",keyword:"required",params:{missingProperty: missing12},message:"must have required property '"+missing12+"'"};
if(vErrors === null){
vErrors = [err74];
}
else {
vErrors.push(err74);
}
errors++;
}
}
else {
const err75 = {instancePath,schemaPath:"#/oneOf/2/allOf/6/oneOf/1/allOf/1/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err75];
}
else {
vErrors.push(err75);
}
errors++;
}
}
var valid49 = _errs134 === errors;
}
var _valid4 = _errs129 === errors;
if(_valid4 && valid43){
valid43 = false;
passing4 = [passing4, 1];
}
else {
if(_valid4){
valid43 = true;
passing4 = 1;
}
}
if(!valid43){
const err76 = {instancePath,schemaPath:"#/oneOf/2/allOf/6/oneOf",keyword:"oneOf",params:{passingSchemas: passing4},message:"must match exactly one schema in oneOf"};
if(vErrors === null){
vErrors = [err76];
}
else {
vErrors.push(err76);
}
errors++;
}
else {
errors = _errs117;
if(vErrors !== null){
if(_errs117){
vErrors.length = _errs117;
}
else {
vErrors = null;
}
}
}
var valid18 = _errs116 === errors;
}
}
}
}
}
}
var _valid0 = _errs46 === errors;
if(_valid0 && valid0){
valid0 = false;
passing0 = [passing0, 2];
}
else {
if(_valid0){
valid0 = true;
passing0 = 2;
}
}
}
if(!valid0){
const err77 = {instancePath,schemaPath:"#/oneOf",keyword:"oneOf",params:{passingSchemas: passing0},message:"must match exactly one schema in oneOf"};
if(vErrors === null){
vErrors = [err77];
}
else {
vErrors.push(err77);
}
errors++;
validate31.errors = vErrors;
return false;
}
else {
errors = _errs0;
if(vErrors !== null){
if(_errs0){
vErrors.length = _errs0;
}
else {
vErrors = null;
}
}
}
validate31.errors = vErrors;
return errors === 0;
}

const wrapper1 = {validate: validate28};
const func4 = require("ajv/dist/runtime/ucs2length").default;

function validate28(data, {instancePath="", parentData, parentDataProperty, rootData=data}={}){
let vErrors = null;
let errors = 0;
const _errs1 = errors;
if(!(validate29(data, {instancePath,parentData,parentDataProperty,rootData}))){
vErrors = vErrors === null ? validate29.errors : vErrors.concat(validate29.errors);
errors = vErrors.length;
}
var valid0 = _errs1 === errors;
if(valid0){
const _errs2 = errors;
if(!(validate31(data, {instancePath,parentData,parentDataProperty,rootData}))){
vErrors = vErrors === null ? validate31.errors : vErrors.concat(validate31.errors);
errors = vErrors.length;
}
var valid0 = _errs2 === errors;
}
if(errors === 0){
if(data && typeof data == "object" && !Array.isArray(data)){
let missing0;
if((data.nodeType === undefined) && (missing0 = "nodeType")){
validate28.errors = [{instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: missing0},message:"must have required property '"+missing0+"'"}];
return false;
}
else {
const _errs3 = errors;
for(const key0 in data){
if(!(((((((key0 === "nodeType") || (key0 === "children")) || (key0 === "leafType")) || (key0 === "questionLabel")) || (key0 === "value")) || (key0 === "operation")) || (key0 === "secondValue"))){
validate28.errors = [{instancePath,schemaPath:"#/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key0},message:"must NOT have additional properties"}];
return false;
break;
}
}
if(_errs3 === errors){
if(data.nodeType !== undefined){
let data0 = data.nodeType;
const _errs4 = errors;
if(typeof data0 !== "string"){
validate28.errors = [{instancePath:instancePath+"/nodeType",schemaPath:"#/properties/nodeType/type",keyword:"type",params:{type: "string"},message:"must be string"}];
return false;
}
if(!((((data0 === "and") || (data0 === "or")) || (data0 === "not")) || (data0 === "leaf"))){
validate28.errors = [{instancePath:instancePath+"/nodeType",schemaPath:"#/properties/nodeType/enum",keyword:"enum",params:{allowedValues: schema46.properties.nodeType.enum},message:"must be equal to one of the allowed values"}];
return false;
}
var valid1 = _errs4 === errors;
}
else {
var valid1 = true;
}
if(valid1){
if(data.children !== undefined){
let data1 = data.children;
const _errs6 = errors;
if(errors === _errs6){
if(Array.isArray(data1)){
var valid2 = true;
const len0 = data1.length;
for(let i0=0; i0<len0; i0++){
const _errs8 = errors;
if(!(wrapper1.validate(data1[i0], {instancePath:instancePath+"/children/" + i0,parentData:data1,parentDataProperty:i0,rootData}))){
vErrors = vErrors === null ? wrapper1.validate.errors : vErrors.concat(wrapper1.validate.errors);
errors = vErrors.length;
}
var valid2 = _errs8 === errors;
if(!valid2){
break;
}
}
}
else {
validate28.errors = [{instancePath:instancePath+"/children",schemaPath:"#/properties/children/type",keyword:"type",params:{type: "array"},message:"must be array"}];
return false;
}
}
var valid1 = _errs6 === errors;
}
else {
var valid1 = true;
}
if(valid1){
if(data.leafType !== undefined){
let data3 = data.leafType;
const _errs9 = errors;
if(typeof data3 !== "string"){
validate28.errors = [{instancePath:instancePath+"/leafType",schemaPath:"#/properties/leafType/type",keyword:"type",params:{type: "string"},message:"must be string"}];
return false;
}
if(!(((((data3 === "question") || (data3 === "slider")) || (data3 === "date")) || (data3 === "text")) || (data3 === "table"))){
validate28.errors = [{instancePath:instancePath+"/leafType",schemaPath:"#/properties/leafType/enum",keyword:"enum",params:{allowedValues: schema46.properties.leafType.enum},message:"must be equal to one of the allowed values"}];
return false;
}
var valid1 = _errs9 === errors;
}
else {
var valid1 = true;
}
if(valid1){
if(data.questionLabel !== undefined){
const _errs11 = errors;
if(typeof data.questionLabel !== "string"){
validate28.errors = [{instancePath:instancePath+"/questionLabel",schemaPath:"#/properties/questionLabel/type",keyword:"type",params:{type: "string"},message:"must be string"}];
return false;
}
var valid1 = _errs11 === errors;
}
else {
var valid1 = true;
}
if(valid1){
if(data.value !== undefined){
let data5 = data.value;
const _errs13 = errors;
if(((!((typeof data5 == "number") && (isFinite(data5)))) && (typeof data5 !== "string")) && (typeof data5 !== "boolean")){
validate28.errors = [{instancePath:instancePath+"/value",schemaPath:"#/properties/value/type",keyword:"type",params:{type: schema46.properties.value.type},message:"must be number,string,boolean"}];
return false;
}
var valid1 = _errs13 === errors;
}
else {
var valid1 = true;
}
if(valid1){
if(data.operation !== undefined){
let data6 = data.operation;
const _errs15 = errors;
const _errs16 = errors;
let valid3 = false;
const _errs17 = errors;
if(typeof data6 !== "string"){
const err0 = {instancePath:instancePath+"/operation",schemaPath:"#/properties/operation/anyOf/0/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
if(!((((((((data6 === "less") || (data6 === "lessEqual")) || (data6 === "greater")) || (data6 === "greaterEqual")) || (data6 === "equals")) || (data6 === "notEquals")) || (data6 === "between")) || (data6 === "answered"))){
const err1 = {instancePath:instancePath+"/operation",schemaPath:"#/properties/operation/anyOf/0/enum",keyword:"enum",params:{allowedValues: schema46.properties.operation.anyOf[0].enum},message:"must be equal to one of the allowed values"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
var _valid0 = _errs17 === errors;
valid3 = valid3 || _valid0;
if(!valid3){
const _errs19 = errors;
if(errors === _errs19){
if(typeof data6 === "string"){
if(func4(data6) > 0){
const err2 = {instancePath:instancePath+"/operation",schemaPath:"#/properties/operation/anyOf/1/maxLength",keyword:"maxLength",params:{limit: 0},message:"must NOT have more than 0 characters"};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
}
else {
const err3 = {instancePath:instancePath+"/operation",schemaPath:"#/properties/operation/anyOf/1/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
}
var _valid0 = _errs19 === errors;
valid3 = valid3 || _valid0;
}
if(!valid3){
const err4 = {instancePath:instancePath+"/operation",schemaPath:"#/properties/operation/anyOf",keyword:"anyOf",params:{},message:"must match a schema in anyOf"};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
validate28.errors = vErrors;
return false;
}
else {
errors = _errs16;
if(vErrors !== null){
if(_errs16){
vErrors.length = _errs16;
}
else {
vErrors = null;
}
}
}
var valid1 = _errs15 === errors;
}
else {
var valid1 = true;
}
if(valid1){
if(data.secondValue !== undefined){
let data7 = data.secondValue;
const _errs21 = errors;
if((!((typeof data7 == "number") && (isFinite(data7)))) && (typeof data7 !== "string")){
validate28.errors = [{instancePath:instancePath+"/secondValue",schemaPath:"#/properties/secondValue/type",keyword:"type",params:{type: schema46.properties.secondValue.type},message:"must be number,string"}];
return false;
}
var valid1 = _errs21 === errors;
}
else {
var valid1 = true;
}
}
}
}
}
}
}
}
}
}
else {
validate28.errors = [{instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object"}];
return false;
}
}
validate28.errors = vErrors;
return errors === 0;
}


function validate27(data, {instancePath="", parentData, parentDataProperty, rootData=data}={}){
/*# sourceURL="validateSimplified" */;
let vErrors = null;
let errors = 0;
if(errors === 0){
if(data && typeof data == "object" && !Array.isArray(data)){
let missing0;
if((data.condition === undefined) && (missing0 = "condition")){
validate27.errors = [{instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: missing0},message:"must have required property '"+missing0+"'"}];
return false;
}
else {
const _errs1 = errors;
for(const key0 in data){
if(!(key0 === "condition")){
validate27.errors = [{instancePath,schemaPath:"#/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key0},message:"must NOT have additional properties"}];
return false;
break;
}
}
if(_errs1 === errors){
if(data.condition !== undefined){
if(!(validate28(data.condition, {instancePath:instancePath+"/condition",parentData:data,parentDataProperty:"condition",rootData}))){
vErrors = vErrors === null ? validate28.errors : vErrors.concat(validate28.errors);
errors = vErrors.length;
}
}
}
}
}
else {
validate27.errors = [{instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object"}];
return false;
}
}
validate27.errors = vErrors;
return errors === 0;
}
